import React, { useEffect, useState } from 'react';
import { Grid, Snackbar } from '@material-ui/core';
import Alert from "@material-ui/lab/Alert";
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
import Form from 'components/Form/FormTwoColumns';
import { useStyles } from "./style";
import { NavigateNext, PlayArrow } from '@material-ui/icons';
import ApiServices from 'services/ApiServices';
import {showMessagePersonalizedPosition, showMessageSuccessSimple} from 'services/SweetAlert'
import LoadingSpinner from 'components/LoadingSpinner';
import MensajeAlerta from 'components/ResponseElement'
import RechazarPorCasoEspecial from '../RechazarPorCasoEspecial'
import DialogLoadingMessage from 'components/BackDrop';
import allActions from 'store/actions';
import { useSelector, useDispatch } from 'react-redux'
import AlertErrors from 'components/AlertErrors'
import ComponenteValidandoEstadosDelPadron from'./ValidarEstadosPadron'
import { useHistory } from "react-router-dom";

let catalogoDiscapacidad = []
let catalogoClasificacionDeDiscapacidad = []

function CreateUpdateUser(props) {  
    let history = useHistory();
    const controller ='solicitudesDeEmpadronamiento';
    const [dispacidadesEntrantes] = useState(props.datosSolicitudExtranjero.discapacidades);
    const classes = useStyles()
    const dispatch = useDispatch();
    catalogoDiscapacidad = useSelector(state => state.solicitudEmpadronamientoExtranjero.catalogoDiscapacidad)
    catalogoClasificacionDeDiscapacidad = useSelector(state => state.solicitudEmpadronamientoExtranjero.catalogoClasificacionDeDiscapacidad)

    const [loadingMessage, setLoadingMessage] = useState({loading:false, title:''}),
    [mensaje, setMensaje] = useState({tipoError:'', tipoMensaje:''}),
    [analfabeta, setAnalfabeta] = useState(props.datosSolicitudExtranjero.alfabetismo),
    [noVidente, setNovidente] = useState(props.datosSolicitudExtranjero.noVidente),
    [alertaAnalfabetaNoVidente, setAlertaAnalfabetaNoVidente] = useState(''),
    [loadingStateCity, setLoadingStateCity] = useState({loading:false, title:''}),
    [openRechazarProCasoEspecial, setOpenRechazarProCasoEspecial] = useState(false),
    [openAlertaGeneral, setOpenAlertaGeneral] = useState(true),
    [open, setOpen] = useState(false);
    let idDepartamento = 0, idMunicipio = 0; 
    let idDepartamentoResidencia='', idMunicipioResidencia='', cenVotacion=''; 
    let idDepartamentoVecindad='', idDepartamentoNacimiento='';
    let paisSeleccionado= '', estadoDelPaisSeleccionado='';
    let ArrayAlfabetismo =[ {id: '0', name: 'No lee, No Escribe'},{id: '1', name: 'Lee'},{id: '2', name: 'Escribe'},{id: '3', name: 'Lee, Escribe'}]
    let ArrayGenero =[ {id: '0', name: 'Femenino'}, {id: '1', name: 'Masculino'},]
    let ArrayNoVidentePadron =[ {id:'0', name: 'Vidente'}, {id: '1', name: 'No vidente'}]
    let ArrayNoVidenteRenap =[ {id:'0', name: 'No Vidente'}, {id: '1', name: 'Vidente'}]
    let description = [
        {name: "- Antes de continuar, revise que la información que ingresó esté correcta.",},
        {name: "- Datos requeridos (*)."}
    ]
    let saveData = {};
    const [posicionCiudad, setPosicionCiudad] = useState('')
    let isReturn = false;
    const [errors, setErrors] = useState({error: [], open: false})
    let newErrors = []
    //consultar en el store por medio del iddepartamento si existe ya un municipio    
    const obtenerPaises =async ()=>{
        elements['pais'].list=[];
        setLoadingStateCity({loading: true, title:'Cargando paises. Espere un momento ...'})
        let newElements= Object. assign({}, elements); 
        if(props.catalogos?.paises.length > 0){
            newElements.pais.list= props.catalogos?.paises
            setElements(newElements);
            setLoadingStateCity({loading: false, title:''})
            return;
        }else{            
            if(props.ArrayListado?.ArrayPais?.length === 0 || elements.pais.value != props.datosSolicitudExtranjero?.pais){
                try{
                    let response = await ApiServices.paises.listRegisterCriteria();
                    if(response.error){
                        // setCargandoDatos(false);
                    }else {
                            const newData = response?.data.filter( item => item.id !== 1);
                            newElements.pais.list= newData || response.data
                            props.SOLICITUD_EMPADRONAMIENTO_SET_CATALOGOS_PAISES(newElements.pais.list)
                        } 
                    }catch(exception){
                        newElements.pais.list=[];
                    }
            }else{
                newElements.pais.list = props.ArrayListado.ArrayPais                    
            }
        }        
        setLoadingStateCity({loading: false, title:''})
        setElements(newElements);
    };
    //consultar en el store por medio del id si existe ya un estado y ciudad    
    const ObtenerEstadoDelPaisEnMemoria = (paisSeleccionado) =>{
        let newElements= Object. assign({}, elements);    
        const currentMunicipality = props.catalogos?.estadoDelPais?.filter( ({paisId}) => Number(paisId) === Number(paisSeleccionado));
        if(currentMunicipality?.length > 0) {
            // elements.ciudadResidencia.list = [];
            // elements.ciudadResidencia.value = null;
            // elements.estadoResidencia.value =  null;            
            newElements.estadoResidencia.list=currentMunicipality;
            setElements(newElements);
            setLoadingStateCity({loading: false, title:''})
            return true;
        } else return false;
    }    
    const ObtenerCiudadDelEstadoDelPaisEnMemoria = (paisSeleccionado, estadoDelPaisSeleccionado) =>{
        let newElements= Object. assign({}, elements);
        if(elements.pais.value === null || elements.estadoResidencia.value === null) return;

        const currentMunicipality = props.catalogos?.ciudadDelEstadoDelPais?.filter( ({paisId, estadoId}) => Number(paisId) === Number(paisSeleccionado) && Number(estadoId) === Number(estadoDelPaisSeleccionado));
        if(currentMunicipality?.length > 0) {
            // newElements.ciudadResidencia.list = [];
            // newElements.ciudadResidencia.value = null;
            // newElements.estadoResidencia.value =  null;            
            newElements.ciudadResidencia.list=currentMunicipality;
            setElements(newElements);
            setLoadingStateCity({loading: false, title:''})
            return true;
        } else return false;
    }        
    const obtenerEstadoDelPais =async (event)=>{
        let newElements= Object. assign({}, elements);
        if(event === undefined){
            if(props.datosSolicitudExtranjero.pais?.id === undefined){
                // paisSeleccionado = undefined;
                // newElements.estadoResidencia.value =  null;
                // newElements.estadoResidencia.list =  [];
                // newElements.ciudadResidencia.value =  null;
                // newElements.ciudadResidencia.list =  []   
                return;                
            }else{
                if(elements.pais.value === null){
                    paisSeleccionado = props.datosSolicitudExtranjero.pais?.id;
                }else{
                    paisSeleccionado = elements.pais.value?.id;
                }                
            }
        }
        else {
            if(event?.target?.value === ""){
                newElements.estadoResidencia.value =  null;
                newElements.estadoResidencia.list =  [];
                newElements.ciudadResidencia.value =  null;
                newElements.ciudadResidencia.list =  []   
                return;
            }
            paisSeleccionado =  (typeof event.target.value == 'object') ? event.target.value?.id : event.target.value;
            newElements.estadoResidencia.value =  null;
            newElements.ciudadResidencia.value =  null;
            newElements.ciudadResidencia.list =  []    
            isReturn = ObtenerEstadoDelPaisEnMemoria(paisSeleccionado)           
        }
        
        setLoadingStateCity({loading: true, title:'Cargando estados del país. Espere un momento ...'})
        
        if((paisSeleccionado === undefined || paisSeleccionado === "")){
            newElements.estadoResidencia.value =  null;
            newElements.estadoResidencia.list =  [];
            newElements.ciudadResidencia.value =  null;
            newElements.ciudadResidencia.list =  []
        }else{
            if(elements.pais.value !== null){
                isReturn = ObtenerEstadoDelPaisEnMemoria(paisSeleccionado)
            }
            if(isReturn){
                // elements.ciudadResidencia.list = [];
                // elements.ciudadResidencia.value = null;                
                setLoadingStateCity({loading: false, title:''})
                return;
            }else{
                if(elements.pais.value !== null){                    
                    try{
                        ApiServices.estadosDePaises.searchCriteria.clear();
                        ApiServices.estadosDePaises.searchCriteria.setOperator("and");
                        ApiServices.estadosDePaises.searchCriteria.addEquals("paisId",paisSeleccionado);
                        ApiServices.estadosDePaises.setIsPublic(true);
                        let response =await ApiServices.estadosDePaises.listRegisterCriteria();
            
                        if(response.error){
                            newElements.estadoResidencia.list=[];
                        }else {                
                                if(props.datosSolicitudExtranjero.pais) {
                                    if(props.datosSolicitudExtranjero.pais?.id != elements['pais'].value?.id) {
                                        newElements.estadoResidencia.value =  null;
                                        newElements.ciudadResidencia.value =  null;
                                        newElements.ciudadResidencia.list =  []
                                    }
                                } else {
                                    newElements.estadoResidencia.value =  null;
                                    newElements.ciudadResidencia.value =  null;
                                    newElements.ciudadResidencia.list =  []
                                }      
                                newElements.estadoResidencia.list=response.data;
                                props.SOLICITUD_EMPADRONAMIENTO_SET_CATALOGOS_ESTADO_DEL_PAIS(newElements.estadoResidencia.list)
                            }
                    }catch(exception){
                        newElements.estadoResidencia.value =  null;
                        newElements.ciudadResidencia.value =  null;
                        newElements.ciudadResidencia.list =  []
                        newElements.estadoResidencia.list=[];
                    }
                }
            }                
        }
        setLoadingStateCity({loading: false, title:''})
        setElements(newElements);
    };
    const obtenerCiudadDelEstadoDelPais =async (event)=>{
        let newElements= Object. assign({}, elements); 
        // paisSeleccionado = (typeof paisSeleccionado == 'object') ? paisSeleccionado.id : paisSeleccionado;

        if(event === undefined) {
            if(props.datosSolicitudExtranjero.estadoResidencia?.id === undefined){
                estadoDelPaisSeleccionado = "";
                // elements.ciudadResidencia.value =  null;
                return;                
            }else{
                if(elements.pais.value === null && elements.estadoResidencia.value === null){
                    paisSeleccionado = props.datosSolicitudExtranjero.pais?.id;
                    estadoDelPaisSeleccionado = props.datosSolicitudExtranjero.estadoResidencia?.id;
                }else{
                    paisSeleccionado = elements.pais.value?.id;
                    estadoDelPaisSeleccionado = elements.estadoResidencia.value?.id;
                }
            }                        
        }
        else {
            if(event?.target?.value === ""){
                newElements.ciudadResidencia.value =  null;
                newElements.ciudadResidencia.list =  []   
                return;
            }
            if(!paisSeleccionado) {
                return
            };
            estadoDelPaisSeleccionado =  (typeof event.target.value == 'object') ? event.target.value?.id : event.target.value;            
            newElements.ciudadResidencia.value =  null;
            isReturn = ObtenerCiudadDelEstadoDelPaisEnMemoria(paisSeleccionado, estadoDelPaisSeleccionado)
        }
        if((paisSeleccionado !== "" && estadoDelPaisSeleccionado !== "")){
            setLoadingStateCity({loading: true, title:'Cargando ciudades del estado del país ...'})
            isReturn = ObtenerCiudadDelEstadoDelPaisEnMemoria(paisSeleccionado, estadoDelPaisSeleccionado)
            if(isReturn){
                setLoadingStateCity({loading: false, title:''})
                return;
            }else{
                if(elements.estadoResidencia.value !== null){
                    try{
                        ApiServices.ciudades.searchCriteria.clear();
                        ApiServices.ciudades.orderCriteria.clear();
                        ApiServices.ciudades.searchCriteria.setOperator("and");
                        ApiServices.ciudades.searchCriteria.addEquals("paisId", paisSeleccionado);
                        ApiServices.ciudades.searchCriteria.addEquals("estadoId",estadoDelPaisSeleccionado);
                        ApiServices.ciudades.orderCriteria.addAsc("id");
                        let response =await ApiServices.ciudades.listRegisterCriteria();
                        if(response.error){
                            newElements.ciudadResidencia.list=[];
                        }else {          
                                if(props.datosSolicitudExtranjero.estadoResidencia) {
                                    if(props.datosSolicitudExtranjero.estadoResidencia?.id != elements['estadoResidencia'].value?.id) {
                                        elements.ciudadResidencia.value =  null;
                                    }
                                } else {
                                    elements.ciudadResidencia.value =  null;
                                }       
                                newElements.ciudadResidencia.list=response.data;
                                props.SOLICITUD_EMPADRONAMIENTO_SET_CATALOGOS_CIUDAD_DEL_ESTADO_DEL_PAIS(response.data)
                                var ciudades = response.data
                                Object.keys(ciudades).forEach((element, key, _array) =>{
                                    if(ciudades[element].id === props.datosSolicitudExtranjero.ciudadResidencia){
                                        setPosicionCiudad(element)
                                    }
                                })                    
                                // ObtenerNombreComunidad(response.data)
                            }
                    }catch(exception){
                        elements.ciudadResidencia.value =  null;
                        newElements.ciudadResidencia.list=[];
                    }
                }
            }
        }else{
            elements.ciudadResidencia.value =  null;
            elements.ciudadResidencia.list =  [];
        }
        setLoadingStateCity({loading: false, title:''})
        setElements(newElements);
    };    
    let isFindState = false
    const obtenerDepartamentos =async ()=>{
        setLoadingStateCity({loading: true, title:'Cargando departamentos ...'})
        let newElements= Object. assign({}, elements); 
        if((props.catalogos?.departamentoVecindad.length > 0)){
            newElements.departamentoVecindad.list = props.catalogos?.departamentoVecindad
            isFindState = true
        }
        if((props.catalogos?.departamentoNacimiento.length > 0)){
            newElements.departamentoNacimiento.list = props.catalogos?.departamentoNacimiento
            isFindState = true
        }
        if((props.catalogos?.departamentoResidencia.length > 0)){
            newElements.departamentoResidencia.list = props.catalogos?.departamentoResidencia
            isFindState = true
        }
        if(isFindState){
            setLoadingStateCity({loading: false, title:''})
            setElements(newElements);
            return ;
        }

        try{
            let response = await ApiServices.departamentos.listRegisterCriteria();
            if(response.error){
            }else {  
                var datos = response.data
                Object.keys(datos).forEach((element, key, _array) =>{
                    if(datos[element].id === "23" ){
                    }else{                        
                        newElements.departamentoVecindad.list.push({
                            id: datos[element].id,
                            name: datos[element].name,
                            municipios:[]
                        });
                    }
                    if(datos[element].id === "23" || datos[element].id === "24" || datos[element].id === "25"){
                    }else{
                        newElements.departamentoResidencia.list.push({
                            id: datos[element].id,
                            name: datos[element].name,
                            municipios:[]
                        });                                
                    }

                    if(datos[element].id === "23" || datos[element].id === "25"){
                    }else{
                        newElements.departamentoNacimiento.list.push({
                            id: datos[element].id,
                            name: datos[element].name,
                            municipios:[]
                        });
                    }
                }) 
                props.SOLICITUD_EMPADRONAMIENTO_SET_CATALOGOS_DEPARTAMENTO_VECINDAD(newElements.departamentoVecindad.list)
                props.SOLICITUD_EMPADRONAMIENTO_SET_CATALOGOS_DEPARTAMENTO_NACIMIENTO(newElements.departamentoNacimiento.list)
                props.SOLICITUD_EMPADRONAMIENTO_SET_CATALOGOS_DEPARTAMENTO_RESIDENCIA(newElements.departamentoResidencia.list)
            } 
        }catch(exception){
            newElements.departamentoNacimiento.list=[];
        }
        setLoadingStateCity({loading: false, title:''})
        setElements(newElements);
    };
    //cargamos los municipios en base al departamento vecindad seleccionado      
    let getDepartamentoResidencia = '', getMunicipioResidencia = ''
    const obtenerMuninipiosResidencia =async (event)=>{
        setLoadingStateCity({loading: true, title:'Cargando municipios de residencia ...'})
        let newElements= Object. assign({}, elements); 
        if(event !== undefined) {
            if(event?.target?.value === "") {
                elements.municipioResidencia.list = [];
                elements.municipioResidencia.value = null;
                elements.comunidadResidencia.value = null                
                elements.comunidadResidencia.list = [];
                elements.comunidadCodigoGeoelectoral.value={title: 'Comunidad', value: ''}
                elements.centroVotacionCodigoGeoelectoral.value={title: 'Centro de Votación', value: ''}                
                setLoadingStateCity({loading: false, title:''})
                return;
            }
            idDepartamentoResidencia = event.target.value;
            elements.municipioResidencia.value =  null;
            elements.comunidadResidencia.value = null            
            elements.comunidadResidencia.list = [];
            elements.comunidadCodigoGeoelectoral.value={title: 'Comunidad', value: ''}
            elements.centroVotacionCodigoGeoelectoral.value={title: 'Centro de Votación', value: ''}            
            getDepartamentoResidencia = idDepartamentoResidencia
            isReturn = ObtenerMunicipiosEnMemoria('municipioResidencia', 'departamentoResidencia', idDepartamentoResidencia)
        } else {
            if(!newElements.departamentoResidencia.value?.id || !newElements.municipioResidencia.value?.id){
                elements.comunidadCodigoGeoelectoral.value={title: 'Comunidad', value: ''}
                elements.centroVotacionCodigoGeoelectoral.value={title: 'Centro de Votación', value: ''}
            }
            if(!getDepartamentoResidencia){
                idDepartamentoResidencia = props.datosSolicitudExtranjero.departamentoResidencia?.id
                isReturn = ObtenerMunicipiosEnMemoria('municipioResidencia', 'departamentoResidencia', idDepartamentoResidencia)
            }else{
                isReturn = ObtenerMunicipiosEnMemoria('municipioResidencia', 'departamentoResidencia', getDepartamentoResidencia)
            }
        } 
        if(isReturn){
            setLoadingStateCity({loading: false, title:''})
            return;
        }else{
            try{
                ApiServices.municipios.searchCriteria.clear();
                ApiServices.municipios.searchCriteria.setOperator("and");
                ApiServices.municipios.searchCriteria.addEquals("departamentoId",idDepartamentoResidencia);
                ApiServices.municipios.setIsPublic(true);
                let response =await ApiServices.municipios.listRegisterCriteria();
                if(response.error){
                    newElements.municipioResidencia.list=[];
                }else {               
                        if(props.datosSolicitudExtranjero.municipioResidencia) {
                            if(props.datosSolicitudExtranjero.departamentoResidencia?.id != elements['departamentoResidencia'].value?.id) {
                                elements.municipioResidencia.value =  null;
                                elements.comunidadCodigoGeoelectoral.value={title: 'Comunidad', value: ''}
                                elements.centroVotacionCodigoGeoelectoral.value={title: 'Centro de Votación', value: ''}
                            }
                        } else {
                            elements.municipioResidencia.value =  null;
                            elements.comunidadCodigoGeoelectoral.value={title: 'Comunidad', value: ''}
                            elements.centroVotacionCodigoGeoelectoral.value={title: 'Centro de Votación', value: ''}
                        }                         
                        props.SOLICITUD_EMPADRONAMIENTO_SET_CATALOGOS_MUNICIPIOS(response.data)                        
                        newElements.municipioResidencia.list=response.data;                        
                    }                    
            }catch(exception){
                elements.municipioResidencia.value =  null;
                newElements.municipioResidencia.list=[];
            }                    
        }        
        setLoadingStateCity({loading: false, title:''})
        setElements(newElements);
    };
    //consultar en el store por medio del iddepartamento si existe ya un municipio    
    const ObtenerMunicipiosEnMemoria = (municipio, departamento, idDepartamento) =>{
        let newElements= Object. assign({}, elements); 
        if(elements[departamento]?.value?.id === undefined){
            elements[municipio].list = [];
            elements[municipio].value =  null;
            return true;
        }
        const currentMunicipality = props.catalogos?.municipios?.filter( ({departamentoId}) => Number(departamentoId) === Number(idDepartamento));
        if(currentMunicipality?.length > 0) {
            newElements[municipio].list=currentMunicipality;
            setElements(newElements);
            setLoadingStateCity({loading: false, title:''})
            return true;
        } else return false;
    }
    //cargamos los municipios en base al departamento Vecindad seleccionado
    let getDepartamentoVecindad = ''
    const obtenerMuninipiosVecindad =async (event)=>{
        setLoadingStateCity({loading: true, title:'Cargando municipios de vecindad ...'})
        let newElements= Object. assign({}, elements); 
        if(event !== undefined) {
            if(event?.target?.value === "") {
                elements.municipioVecindad.list = [];
                elements.municipioVecindad.value =  null;
                setLoadingStateCity({loading: false, title:''})
                return;
            }
            idDepartamentoVecindad = event.target.value;
            getDepartamentoVecindad = idDepartamentoVecindad
            elements.municipioVecindad.value =  null
            isReturn = ObtenerMunicipiosEnMemoria('municipioVecindad', 'departamentoVecindad', idDepartamentoVecindad)
        } else {
            if(!getDepartamentoVecindad){
                idDepartamentoVecindad = props.datosSolicitudExtranjero.departamentoVecindadDPI?.id;                
                isReturn = ObtenerMunicipiosEnMemoria('municipioVecindad', 'departamentoVecindad', idDepartamentoVecindad)
            }else{
                isReturn = ObtenerMunicipiosEnMemoria('municipioVecindad', 'departamentoVecindad', getDepartamentoVecindad)
            }
        } 
        if(isReturn){
            setLoadingStateCity({loading: false, title:''})
            return;
        }else{
            try{
                ApiServices.municipios.searchCriteria.clear();
                ApiServices.municipios.searchCriteria.setOperator("and");
                ApiServices.municipios.searchCriteria.addEquals("departamentoId",idDepartamentoVecindad);
                ApiServices.municipios.setIsPublic(true);
                let response =await ApiServices.municipios.listRegisterCriteria();
                if(response.error){
                    newElements.municipioVecindad.list=[];
                }else {               
                        if(props.datosSolicitudExtranjero.municipioVecindadDPI) {
                            if(props.datosSolicitudExtranjero.departamentoVecindadDPI?.id != elements['departamentoVecindad'].value?.id) {
                                elements.municipioVecindad.value =  null;
                            }
                        } else {
                            elements.municipioVecindad.value =  null;
                        }                         
                        props.SOLICITUD_EMPADRONAMIENTO_SET_CATALOGOS_MUNICIPIOS(response.data)                        
                        newElements.municipioVecindad.list=response.data;                        
                    }                    
            }catch(exception){
                elements.municipioVecindad.value =  null;
                newElements.municipioVecindad.list=[];
            }                    
        }
        setLoadingStateCity({loading: false, title:''})
        setElements(newElements);
    };
    //cargamos los municipios en base al departamento nacimiento seleccionado        
    let getDepartamentoNacimiento = ''
    const obtenerMuninipiosNacimiento =async (event)=>{
        setLoadingStateCity({loading: true, title:'Cargando municipios de nacimiento ...'})
        let newElements= Object. assign({}, elements); 
        if(event !== undefined) {
            if(event?.target?.value === "") {
                elements.municipioNacimiento.list = [];
                elements.municipioNacimiento.value =  null;
                setLoadingStateCity({loading: false, title:''})
                return;
            }
            idDepartamentoNacimiento = event.target.value;
            getDepartamentoNacimiento = idDepartamentoNacimiento
            elements.municipioNacimiento.value =  null
            isReturn = ObtenerMunicipiosEnMemoria('municipioNacimiento', 'departamentoNacimiento',  idDepartamentoNacimiento)
        } else {
            if(!getDepartamentoNacimiento){
                idDepartamentoNacimiento = props.datosSolicitudExtranjero.departamentoNacimiento?.id;                
                isReturn = ObtenerMunicipiosEnMemoria('municipioNacimiento', 'departamentoNacimiento', idDepartamentoNacimiento)
            }else{
                isReturn = ObtenerMunicipiosEnMemoria('municipioNacimiento', 'departamentoNacimiento', getDepartamentoNacimiento)
            }
        } 
        if(isReturn){
            setLoadingStateCity({loading: false, title:''})
            return;
        }else{
            try{
                ApiServices.municipios.searchCriteria.clear();
                ApiServices.municipios.searchCriteria.setOperator("and");
                ApiServices.municipios.searchCriteria.addEquals("departamentoId",idDepartamentoNacimiento);
                ApiServices.municipios.setIsPublic(true);
                let response =await ApiServices.municipios.listRegisterCriteria();
                if(response.error){
                    newElements.municipioNacimiento.list=[];
                }else {               
                        if(props.datosSolicitudExtranjero.municipioNacimiento) {
                            if(props.datosSolicitudExtranjero.departamentoNacimiento?.id != elements['departamentoNacimiento'].value?.id) {
                                elements.municipioNacimiento.value =  null;
                            }
                        } else {
                            elements.municipioNacimiento.value =  null;
                        }                         
                        props.SOLICITUD_EMPADRONAMIENTO_SET_CATALOGOS_MUNICIPIOS(response.data)                                            
                        newElements.municipioNacimiento.list=response.data;                        
                    }                    
            }catch(exception){
                elements.municipioNacimiento.value =  null;
                newElements.municipioNacimiento.list=[];
            }                    
        }        
        setLoadingStateCity({loading: false, title:''})
        setElements(newElements);
    };
    //cargamos las comunidades en base al municipio seleccionado
    const ObtenerComunidadesEnMemoria = (idDepartamentoResidencia, idMunicipioResidencia) =>{
        let newElements= Object. assign({}, elements);
        let departamento = '', municipio = '';
        if(elements.departamentoResidencia.value?.id === idDepartamentoResidencia && elements.municipioResidencia.value?.id === idMunicipioResidencia){
            departamento = idDepartamentoResidencia
            municipio = idMunicipioResidencia
        }else{            
            departamento = elements.departamentoResidencia.value?.id
            municipio = elements.municipioResidencia.value?.id
        }
        const currentMunicipality = props.catalogos?.comunidades?.filter( ({departamentoId, municipioId}) => Number(departamentoId) === Number(departamento) && Number(municipioId) === Number(municipio));
        if(currentMunicipality?.length > 0) {
            // newElements.comunidadResidencia.list = [];
            // newElements.comunidadResidencia.value = null;
            // newElements.estadoResidencia.value =  null;
            newElements.comunidadResidencia.list=currentMunicipality;
            let comunidad = {target:{value: elements.comunidadResidencia.value?.id}}
            ObtenerCodigoGeolectoralSeleccionado(comunidad, currentMunicipality)            
            setElements(newElements);
            setLoadingStateCity({loading: false, title:''})
            return true;
        } else return false;
    }            
    const setComunidad =async (event)=>{
        setLoadingStateCity({loading: true, title:'Cargando comunidades ...'})
        if(!elements.departamentoResidencia.value?.id || !elements.municipioResidencia.value?.id){
            elements.comunidadResidencia.list=[]
            setLoadingStateCity({loading: false, title:''})
            return;
        }
        if(event === undefined) {
            if(props.datosSolicitudExtranjero?.departamentoResidencia?.id === undefined || props.datosSolicitudExtranjero.municipioResidencia?.id === undefined) {
                setLoadingStateCity({loading: false, title:''})
                return;
            }else{
                idDepartamentoResidencia = props.datosSolicitudExtranjero?.departamentoResidencia?.id
                idMunicipioResidencia = props.datosSolicitudExtranjero.municipioResidencia?.id;

            }            
        }
        else if(event?.target?.value === "") {
            idMunicipioResidencia = ""
            elements.comunidadResidencia.list=[];
            elements.comunidadResidencia.value = null
            elements.comunidadCodigoGeoelectoral.value={title: 'Comunidad', value: ''}
            elements.centroVotacionCodigoGeoelectoral.value={title: 'Centro de Votación', value: ''}            
        }
        else {
            idMunicipioResidencia = event.target.value;
            elements.comunidadResidencia.value = null
            elements.comunidadCodigoGeoelectoral.value={title: 'Comunidad', value: ''}
            elements.centroVotacionCodigoGeoelectoral.value={title: 'Centro de Votación', value: ''}
        }        
        
        let newElements= Object. assign({}, elements); 
        if((idDepartamentoResidencia !== "" && idMunicipioResidencia !== "")){
            isReturn = ObtenerComunidadesEnMemoria(idDepartamentoResidencia, idMunicipioResidencia)
            if(isReturn){
                setLoadingStateCity({loading: false, title:''})
                return;
            }else{        
                try{
                    ApiServices.comunidades.searchCriteria.clear();
                    ApiServices.comunidades.searchCriteria.setOperator("and");
                    ApiServices.comunidades.searchCriteria.addEquals("departamentoId", idDepartamentoResidencia);
                    ApiServices.comunidades.searchCriteria.addEquals("municipioId",idMunicipioResidencia);
                    let response =await ApiServices.comunidades.listRegisterCriteria();
                    if(response.error){
                        newElements.comunidadResidencia.list=[];
                    }else {                
                        // if(props.datosSolicitudExtranjero.comunidadResidencia) {
                        //     if(props.datosSolicitudExtranjero.municipioResidencia?.id != elements['municipioResidencia'].value?.id) {
                        //         elements.comunidadResidencia.value = null
                        //     }
                        // } else {
                        //     elements.comunidadResidencia.value = null
                        // }
                        props.SOLICITUD_EMPADRONAMIENTO_SET_CATALOGOS_COMUNIDAD(response.data)                        
                        newElements.comunidadResidencia.list=response.data;
                        let comunidad = {target:{value: elements.comunidadResidencia.value?.id}}
                        ObtenerCodigoGeolectoralSeleccionado(comunidad, response.data)
                    }
                }catch(exception){
                    newElements.comunidadResidencia.list=[];
                    elements.comunidadResidencia.value = null
                }
            }
        }
        setLoadingStateCity({loading: false, title:''})
        setElements(newElements);
    };
    //cargamos las ocupaciones
    const setProfesiones =async ()=>{
        setLoadingStateCity({loading: true, title:'Cargando profesiones ...'})
        let newElements= Object. assign({}, elements); 
        if(props.catalogos.ocupaciones.length === 0){
            try{
                let response = await ApiServices.ocupaciones.listRegisterCriteria();
                newElements.profesion.list=[];
                if(response.error){
                }else {
                    var datos = response.data
                    Object.keys(datos).forEach((element, key, _array) =>{
                        if(datos[element].name !== " "){
                            newElements.profesion.list.push({
                                id: datos[element].id,
                                name: datos[element].name,
                            });
                        }
                    })
                    props.SOLICITUD_EMPADRONAMIENTO_SET_CATALOGOS_OCUPACIONES(newElements.profesion.list)
                } 
            }catch(exception){
                newElements.profesion.list=[];
            }
        }else{
            newElements.profesion.list = props.catalogos?.ocupaciones
        }
        setLoadingStateCity({loading: false, title:''})
        setElements(newElements);
    };          
    const ObtenerNombreComunidad = () =>{
        let datos = elements.comunidadResidencia.list
        Object.keys(datos).forEach((element, key, _array) =>{
            if(datos[element].id === elements.comunidadResidencia.value?.id){
                // nombreComunidad = datos[element].name
                cenVotacion = datos[element].centroVotacionId
                // position3 = element
            }
        }) 
    }    
    const esAnalfabeta = (event) =>{
        setAnalfabeta(event.target.value)
    }
    const esNoVidente = (event) =>{
        setNovidente(event.target.value)
    }

    const CentroDeVotacionParseada = (numero, cantidad) =>{
        return (numero).toString().padStart(cantidad,'0')
    }
    const ObtenerCodigoGeolectoralSeleccionado = (comunidad, lista) =>{
        var datos = lista || elements.comunidadResidencia.list, centroDeVotacion=0;
        let newElements= Object. assign({}, elements); 

        Object.keys(datos).forEach((element, key, _array) =>{
            if(datos[element].id === comunidad?.target?.value){
                centroDeVotacion = datos[element].centroVotacionId
                newElements.comunidadCodigoGeoelectoral.value={title: 'Comunidad', value: CentroDeVotacionParseada(comunidad?.target?.value, 4)}
                newElements.centroVotacionCodigoGeoelectoral.value={title: 'Centro de Votación', value: CentroDeVotacionParseada(centroDeVotacion, 4)}
                setElements(newElements);              
            }
        })         
        if(newElements.comunidadResidencia.value?.id === undefined || newElements.comunidadResidencia.value?.id === 0) {
            newElements.comunidadCodigoGeoelectoral.value={title: 'Comunidad', value: ''}
            newElements.centroVotacionCodigoGeoelectoral.value={title: 'Centro de votación', value: ''}
            setElements(newElements);              
        }           
    }
    //discapacidades
        const funcionObtenerTodasLasDiscapacidades =async ()=>{
            setLoadingStateCity({loading: true, title:'Obteniendo catálogo de discapacidades ...'})
            let newElements= Object. assign({}, elements); 
            if(catalogoDiscapacidad.length === 0)
            {                
                try{
                    let response = await ApiServices.discapacidades.listRegisterCriteria();
                    if(response.error){
                        showMessagePersonalizedPosition('warning','¡Advertencia!', response?.error?.message,'center')
                    }else { 
                        for (let index = 0; index < response.data.length; index++) {
                            newElements.discapacidad.list.push({
                                id: response.data[index].id,
                                name: response.data[index].id+'. '+response.data[index].categoria,
                            });                                                    
                        }
                        dispatch(allActions.setCatalogoDiscapacidad(newElements.discapacidad.list));
                    } 
                }catch(exception){
                    showMessagePersonalizedPosition('error', '¡Advertencia!', "Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.", 'center')
                }
            }else{
                newElements.discapacidad.list = catalogoDiscapacidad;
            }
            setElements(newElements);
            setLoadingStateCity({loading: false, title:''})
        };
    //consultar en el store por medio del iddepartamento si existe ya un municipio    
        const ObtenerClasificacionEnMemoria = (idDiscapacidadEntrante) =>{
            let newElements= Object. assign({}, elements); 
            if(newElements.discapacidad.value?.id === undefined || newElements.discapacidad.value?.id === null || newElements.discapacidad.value?.id === ""){
                newElements.clasificacionDiscapacidad.list = []
                return true;
            }
            if(idDiscapacidadEntrante === undefined || idDiscapacidadEntrante === null || idDiscapacidadEntrante === "" ){
                newElements.clasificacionDiscapacidad.list = []
                return true;
            }
            const getArray = catalogoClasificacionDeDiscapacidad.filter( ({idDiscapacidad}) => Number(idDiscapacidad) === Number(idDiscapacidadEntrante));
            if(getArray?.length > 0) {
                newElements.clasificacionDiscapacidad.options=getArray;
                setElements(newElements);
                setLoadingStateCity({loading: false, title:''})
                return true;
            } else return false;
        }

        const funcionObtenerTodasLasClasificacionesDeDiscapacidades =async (event)=>{
            let idDiscapacidad = '';
            if(event?.target?.value){
                idDiscapacidad = event?.target?.value
            }

            if(idDiscapacidad === undefined || idDiscapacidad === null || idDiscapacidad === ""){
                elements.clasificacionDiscapacidad.options = []
                setLoadingStateCity({loading: false, title:''})
                return;
            }

            setLoadingStateCity({loading: true, title:'Obteniendo catálogo de clasificación de discapacidades ...'})
            let newElements= Object. assign({}, elements); 
            isReturn = ObtenerClasificacionEnMemoria(idDiscapacidad)
            if(isReturn){
                setLoadingStateCity({loading: false, title:''})
                return;
            }else{                
                try{
                    ApiServices.subdiscapacidades.searchCriteria.clear();
                    ApiServices.subdiscapacidades.searchCriteria.setOperator("and");
                    ApiServices.subdiscapacidades.searchCriteria.addEquals("idDiscapacidad",idDiscapacidad);
                    let response = await ApiServices.subdiscapacidades.listRegisterCriteria();
                    if(response.error){
                        showMessagePersonalizedPosition('warning','¡Advertencia!', response?.error?.message,'center')
                    }else { 
                        let newArray = []
                        for (let index = 0; index < response.data.length; index++) {
                            newArray.push({
                                id: response.data[index].id,
                                name: response.data[index].id+'. '+response.data[index].subcategoria,
                                Discapacidad: {id: response.data[index].catalogoDiscapacidad.id, name: response.data[index].catalogoDiscapacidad.categoria},
                                descripcion: response.data[index].descripcion,
                                shortName: response.data[index].subcategoria,
                            });
                        }
                        newElements.clasificacionDiscapacidad.options = newArray
                        dispatch(allActions.setCatalogoClasificacionDiscapacidad(newArray));
                    } 
                }catch(exception){
                    showMessagePersonalizedPosition('error', '¡Advertencia!', "Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.", 'center')
                }
            }
            setElements(newElements);
            setLoadingStateCity({loading: false, title:''})
        };   
        
        const funcionListarDiscapacidadesSeleccionadas = (data) =>{
            let newElements= Object. assign({}, elements);
           
            let getData = []
            newElements.showList.data = []
                for (let index = 0; index < data.length; index++) {
                    getData.push({
                        title: data[index].Discapacidad.name +' - '+data[index].shortName+': ',
                        description: data[index].descripcion,
                    })
                }
            const newValor = dispacidadesEntrantes.concat(getData)
            newElements.showList.data = newValor
            setElements(newElements);
        }
        
        const funcionAsignarDiscapacidadesAsignadas = () =>{
            let newElements= Object. assign({}, elements);
            newElements.showList.data = []
            newElements.showList.data = dispacidadesEntrantes
            setElements(newElements);
        }

    const [elements, setElements] = useState({
    datosEstadoPadron:{
        idelement: "datosEstadoPadron", title:'Estado en el Padrón', position:"center", value: "", currentValue:"", isError:false, elementType:'titleCustom', show: true,
    },        
        nroBoleta:{
            idelement: "nroBoleta", position:"center", value: 'Código de Referencia: '+props.nroBoleta, currentValue: 'Código de Referencia: '+props.nroBoleta, isError:false, elementType:'label'
        },
        estatusPadron:{
            idelement: "estatusPadron", position:"center", value: 'Código Estado Padrón: '+((props.datosSolicitudExtranjero.estadoPadron) ? props.datosSolicitudExtranjero.estadoPadron.codStatus:''),
             isError:false, elementType:'label', currentValue: 'Código Estado Padron: '+((props.datosSolicitudExtranjero.estadoPadron) ? props.datosSolicitudExtranjero.estadoPadron.codStatus:'')
        },
        nombreEstatusPadron:{
            idelement: "nombreEstatusPadron", position:"center", value: 'Estado Padrón: '+((props.datosSolicitudExtranjero.estadoPadron) ? props.datosSolicitudExtranjero.estadoPadron.nombreStatus:''), isError:false, elementType:'label',
            currentValue: 'Estado Padron: '+((props.datosSolicitudExtranjero.estadoPadron) ? props.datosSolicitudExtranjero.estadoPadron.nombreStatus:'')
        },
    datosDPI:{
        idelement: "datosDPI", title:'DATOS DEL DPI', position:"center", value: "", currentValue:"", isError:false, elementType:'titleCustom', show: true,
    },
        cui: { autofocus: true,
            idelement: "cui", value:props.datosSolicitudExtranjero.dpi||"", label: "Número de CUI *", pattern:"^[0-9]*$", validators: ['required'], 
            errorMessages:['CUI requerido, sin espacios al inicio y final'], isError:false, elementType:'input' , initialRequiredLength:13, finalRequiredLength: 13,
            disabled: true, currentValue:props.datosSolicitudExtranjero.dpi||""
        },
        serie: {
            idelement: "serie", value:props.datosSolicitudExtranjero.numeroSerie||"", label: "Número de Serie *", pattern:"^[0-9]*$", validators: ['required'], 
            errorMessages:['Máximo 13 caracteres, sin espacios al inicio y final'], isError:false, elementType:'inputCustom' , 
            disabled: true, currentValue:props.datosSolicitudExtranjero.numeroSerie||"", initialRequiredLength:1, finalRequiredLength: 13,
        },
        fechaEmisionDPI: {
            idelement: "fechaEmisionDPI", value:new Date(props.datosSolicitudExtranjero.fechaEmision)||null, label: "Fecha de Emisión *", pattern:"^[0-9]{1,2}[/][0-9]{1,2}[/][0-9]{4}$", 
            validators: ['required'], errorMessages:['fecha dd/MM/yyyy'], isError:false, elementType:'date' , modified: true,
            disabled: true, currentValue:new Date(props.datosSolicitudExtranjero.fechaEmision)
        },
        departamentoVecindad: {
            idelement: "departamentoVecindad", value:props.datosSolicitudExtranjero.departamentoVecindadDPI||null, label: "Departamento Vecindad *", pattern:"^[1-9][0-9]*$", validators: ['required'],
            errorMessages:['Seleccione el Departamento Vecindad DPI'], isError:false, elementType:'autocompleteV2', list: [],  position:props.datosSolicitudExtranjero.departamentoVecindadDPI-1,
            disabled: ((props.datosSolicitudExtranjero.departamentoVecindadDPI.name === "SIN DATOS") ? false : true), modified: true, 
            handler: obtenerMuninipiosVecindad, focus: {ejecutar: true, function: obtenerDepartamentos},
            currentValue:props.datosSolicitudExtranjero.departamentoVecindadDPI||null,
        },
        municipioVecindad: {
            idelement: "municipioVecindad", value: props.datosSolicitudExtranjero.municipioVecindadDPI||null, label: "Municipio Vecindad *", pattern:"^[1-9][0-9]*$", validators: ['required'], 
            errorMessages:['Seleccione el Municipio Vecindad DPI'], isError:false, elementType:'autocompleteV2', list: [], 
            disabled: props.datosSolicitudExtranjero.municipioVecindadDPI.name === "SIN DATOS" ? false : true, modified: true,
            currentValue: props.datosSolicitudExtranjero.municipioVecindadDPI||null, focus: {ejecutar: true, function: obtenerMuninipiosVecindad}
        },

    datosCiudadano:{
        idelement: "datosCiudadano",title:'DATOS DEL CIUDADANO', position:"center", value: "", currentValue:"", isError:false, elementType:'titleCustom', show: true,
    },
        primerNombre: { 
            idelement: "primerNombre",  value:props.datosSolicitudExtranjero.primerNombre||"", label: "Primer Nombre Ciudadano (a) *", pattern:"^([-\\w_ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()][-\\w_ .\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()]*[-\\w_.\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()])$",
            validators: ['required'], errorMessages:['Requerido, máximo 30 caracteres, sin espacios al inicio y final'], isError:false, elementType:'inputCustom', 
            disabled: true, currentValue:props.datosSolicitudExtranjero.primerNombre||"", initialRequiredLength:1, finalRequiredLength: 30,
        },        
        segundoNombre: { 
            idelement: "segundoNombre",  value:props.datosSolicitudExtranjero.segundoNombre||"" , 
            label: "Segundo Nombre Ciudadano (a)", pattern:"^([-\\w_ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()][-\\w_ .\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()]*[-\\w_.\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()])$", 
            validators: ['requireds'], errorMessages:['Máximo 30 caracteres, sin espacios al inicio y final'], isError:false, elementType:'inputCustom', 
            disabled: true, currentValue:props.datosSolicitudExtranjero.segundoNombre||"", initialRequiredLength: 0, finalRequiredLength: 30
        },        
        primerApellido: { 
            idelement: "primerApellido",  value:props.datosSolicitudExtranjero.primerApellido||"", label: "Primer Apellido Ciudadano (a) *", pattern:"^([-\\w_ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()][-\\w_ .\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()]*[-\\w_.\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()])$", 
            validators: ['required'], errorMessages:['Requerido, máximo 30 caracteres, sin espacios al inicio y final'], isError:false, elementType:'inputCustom', 
            disabled: true, currentValue:props.datosSolicitudExtranjero.primerApellido||"", initialRequiredLength:1, finalRequiredLength: 30,
        },        
        segundoApellido: { 
            idelement: "segundoApellido",  value:props.datosSolicitudExtranjero.segundoApellido||"", label: "Segundo Apellido Ciudadano (a)", pattern:"^([-\\w_ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()][-\\w_ .\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()]*[-\\w_.\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()])$", 
            validators: ['requireds'], errorMessages:['Máximo 30 caracteres, sin espacios al inicio y final'], isError:false, elementType:'inputCustom', 
            disabled: true, currentValue:props.datosSolicitudExtranjero.segundoApellido||"", initialRequiredLength:0, finalRequiredLength: 30,
        },        
        tercerApellido: { 
            idelement: "tercerApellido",  value:props.datosSolicitudExtranjero.apellidoCasada||"", label: "Apellido de Casada", pattern:"^([-\\w_ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()][-\\w_ .\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()]*[-\\w_.\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()])$",
            validators: ['requireds'], errorMessages:['Máximo 30 caracteres, sin espacios al inicio y final'], isError:false, elementType:'inputCustom', 
            disabled: true, currentValue:props.datosSolicitudExtranjero.apellidoCasada||"", initialRequiredLength:0, finalRequiredLength: 30,
        },        
        genero: {
            idelement: "genero", value: props.datosSolicitudExtranjero.genero, label: "Género *", pattern:"^([0-9][0-9]*){1,1}$", validators: ['required'], 
            errorMessages:['Seleccione Género'], isError:false, elementType:'autocomplete', list: [], position: props.datosSolicitudExtranjero.genero, 
            disabled: true, modified: true, currentValue: props.datosSolicitudExtranjero.genero, 
            // errorMessages:['Seleccione Género'], isError:false, elementType:'autocomplete', list: [], position:props.datosResidencia.position8
        },        
        alfabetismo: {
            idelement: "alfabetismo", value:props.datosSolicitudExtranjero.alfabetismo, label: "Alfabetismo *", pattern:"^([0-9][0-9]*){1,1}$", validators: ['required'], 
            errorMessages:['Seleccione una opción'], isError:false, elementType:'autocomplete', list: [], position:props.datosSolicitudExtranjero.alfabetismo,
            handler: esAnalfabeta, disabled:false, modified: false, currentValue:props.datosSolicitudExtranjero.alfabetismo,
            // errorMessages:['Seleccione una opción'], isError:false, elementType:'autocomplete', list: [], position:props.datosResidencia.position9
        },        
        noVidente: {
            idelement: "noVidente", value:props.datosSolicitudExtranjero.noVidente, label: "Vista *", pattern:"^([0-9][0-9]*){1,1}$", validators: ['required'], 
            errorMessages:['Seleccione una opción'], isError:false, elementType:'autocomplete', list: [], position: props.datosSolicitudExtranjero.noVidente,
            handler: esNoVidente, disabled: false, modified: false, currentValue:props.datosSolicitudExtranjero.noVidente,
            // errorMessages:['Seleccione una opción'], isError:false, elementType:'autocomplete', list: [], position:props.datosResidencia.position10
        },        
        fechaNacimiento: {
            idelement: "fechaNacimiento", value:new Date(props.datosSolicitudExtranjero.fechaNacimiento), label: "Fecha de Nacimiento *", pattern:"^[0-9]{1,2}[/][0-9]{1,2}[/][0-9]{4}$", 
            validators: ['required'], errorMessages:['fecha dd/MM/yyyy'], isError:false, elementType:'date' , modified: true,
            disabled: true, currentValue:new Date(props.datosSolicitudExtranjero.fechaNacimiento)
        },
        departamentoNacimiento: {
            idelement: "departamentoNacimiento", value:props.datosSolicitudExtranjero.departamentoNacimiento, label: "Departamento Nacimiento *", pattern:"^[1-9][0-9]*$", validators: ['required'], 
            errorMessages:['Seleccione el Departamento'], isError:false, elementType:'autocompleteV2', list: [], position:props.datosSolicitudExtranjero.departamentoNacimiento-1,
            disabled: true, modified: true, currentValue:props.datosSolicitudExtranjero.departamentoNacimiento, handler: obtenerMuninipiosNacimiento, focus: {ejecutar: true, function: obtenerDepartamentos}
        },
        municipioNacimiento: {
            idelement: "municipioNacimiento", value:props.datosSolicitudExtranjero.municipioNacimiento, label: "Municipio Nacimiento *", pattern:"^^[1-9][0-9]*$", validators: ['required'], 
            errorMessages:['Seleccione el Municipio'], isError:false, elementType:'autocompleteV2', list: [], position:props.datosSolicitudExtranjero.municipioNacimiento-1, 
            disabled: true, modified: true, currentValue:props.datosSolicitudExtranjero.municipioNacimiento, focus: {ejecutar: true, function: obtenerMuninipiosNacimiento}
        },
        nroLibroNacimiento: {
            idelement: "nroLibroNacimiento", value:props.datosSolicitudExtranjero.libro||"", label: "Libro", pattern:"", 
            validators: ['requireds'], errorMessages:['Máximo 10 caracteres, sin espacios al inicio y final'], isError:false, elementType:'inputCustom' ,
            disabled: true, currentValue:props.datosSolicitudExtranjero.libro||"", initialRequiredLength: 0, finalRequiredLength: 20,
        },    
        nroFolioNacimiento: {
            idelement: "nroFolioNacimiento", value:props.datosSolicitudExtranjero.folio||"", label: "Folio", pattern:"", 
            validators: ['requireds'], errorMessages:['Máximo 10 caracteres, sin espacios al inicio y final'], isError:false, elementType:'inputCustom' ,
            disabled: true, currentValue:props.datosSolicitudExtranjero.folio||"", initialRequiredLength: 0, finalRequiredLength: 20,
        },    
        nroPartidaNacimiento: {
            idelement: "nroPartidaNacimiento", value:props.datosSolicitudExtranjero.partida||"", label: "Partida", pattern:"", 
            validators: ['requireds'], errorMessages:['Máximo 10 caracteres, sin espacios al inicio y final'], isError:false, elementType:'inputCustom' ,
            disabled: true, currentValue:props.datosSolicitudExtranjero.partida||"", initialRequiredLength: 0, finalRequiredLength: 20,
        },                                        
        telefono: {
            idelement: "telefono", value:props.datosSolicitudExtranjero.telefono||"", label: "Teléfono", pattern:"^([+0-9_][0-9_ -.\"\']*[0-9_.\"\'])$", 
            validators: ['requireds'], errorMessages:['Máximo 30 caracteres, sin espacios al inicio y final'], isError:false, elementType:'input',
            currentValue:props.datosSolicitudExtranjero.telefono||"", initialRequiredLength: 0, finalRequiredLength: 30
        },                                        
        primerNombrePadre: {
            idelement: "primerNombrePadre",  value:props.datosSolicitudExtranjero.primerNombrePadre||"", label: "Primer Nombre Padre", pattern:"^([-\\w_ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()][-\\w_ .\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()]*[-\\w_.\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()])$",
            validators: ['requireds'], errorMessages:['Máximo 30 caracteres, sin espacios al inicio y final'], isError:false, elementType:'inputCustom', 
            disabled: true, currentValue: props.datosSolicitudExtranjero.primerNombrePadre||"", initialRequiredLength: 0, finalRequiredLength: 30,
        },        
        segundoNombrePadre: { 
            idelement: "segundoNombrePadre",  value:props.datosSolicitudExtranjero.segundoNombrePadre||"", label: "Segundo Nombre Padre", pattern:"^([-\\w_ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()][-\\w_ .\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()]*[-\\w_.\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()])$", 
            validators: ['requireds'], errorMessages:['Máximo 30 caracteres, sin espacios al inicio y final'], isError:false, elementType:'inputCustom', 
            disabled: true, currentValue: props.datosSolicitudExtranjero.segundoNombrePadre||"", initialRequiredLength: 0, finalRequiredLength: 30,
        },        
        primerApellidoPadre: { 
            idelement: "primerApellidoPadre",  value:props.datosSolicitudExtranjero.primerApellidoPadre||"", label: "Primer Apellido Padre", pattern:"^([-\\w_ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()][-\\w_ .\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()]*[-\\w_.\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()])$", 
            validators: ['requireds'], errorMessages:['Máximo 30 caracteres, sin espacios al inicio y final'], isError:false, elementType:'inputCustom', 
            disabled: true, currentValue:props.datosSolicitudExtranjero.primerApellidoPadre||"", initialRequiredLength: 0, finalRequiredLength: 30,
        },        
        segundoApellidoPadre: { 
            idelement: "segundoApellidoPadre",  value:props.datosSolicitudExtranjero.segundoApellidoPadre||"", label: "Segundo Apellido Padre", pattern:"^([-\\w_ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()][-\\w_ .\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()]*[-\\w_.\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()])$", 
            validators: ['requireds'], errorMessages:['Máximo 30 caracteres, sin espacios al inicio y final'], isError:false, elementType:'inputCustom', 
            disabled: true, currentValue:props.datosSolicitudExtranjero.segundoApellidoPadre||"", initialRequiredLength: 0, finalRequiredLength: 30,
        },        
        primerNombreMadre: { 
            idelement: "primerNombreMadre",  value:props.datosSolicitudExtranjero.primerNombreMadre||"", label: "Primer Nombre Madre", pattern:"^([-\\w_ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()][-\\w_ .\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()]*[-\\w_.\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()])$",
            validators: ['requireds'], errorMessages:['Máximo 30 caracteres, sin espacios al inicio y final'], isError:false, elementType:'inputCustom', 
            disabled: true, currentValue:props.datosSolicitudExtranjero.primerNombreMadre||"", initialRequiredLength: 0, finalRequiredLength: 30,
        },        
        segundoNombreMadre: { 
            idelement: "segundoNombreMadre",  value:props.datosSolicitudExtranjero.segundoNombreMadre||"", label: "Segundo Nombre Madre", pattern:"^([-\\w_ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()][-\\w_ .\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()]*[-\\w_.\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()])$",
            validators: ['requireds'], errorMessages:['Máximo 30 caracteres, sin espacios al inicio y final'], isError:false, elementType:'inputCustom', 
            disabled: true, currentValue:props.datosSolicitudExtranjero.segundoNombreMadre||"", initialRequiredLength: 0, finalRequiredLength: 30,
        },        
        primerApellidoMadre: { 
            idelement: "primerApellidoMadre",  value:props.datosSolicitudExtranjero.primerApellidoMadre||"", label: "Primer Apellido Madre", pattern:"^([-\\w_ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()][-\\w_ .\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()]*[-\\w_.\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()])$",
            validators: ['requireds'], errorMessages:['Máximo 30 caracteres, sin espacios al inicio y final'], isError:false, elementType:'inputCustom', 
            disabled: true, currentValue:props.datosSolicitudExtranjero.primerApellidoMadre||"", initialRequiredLength: 0, finalRequiredLength: 30,
        },        
        segundoApellidoMadre: { 
            idelement: "segundoApellidoMadre",  value:props.datosSolicitudExtranjero.segundoApellidoMadre||"", label: "Segundo Apellido Madre", pattern:"^([-\\w_ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()][-\\w_ .\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()]*[-\\w_.\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()])$",
            validators: ['requireds'], errorMessages:['Máximo 30 caracteres, sin espacios al inicio y final'], isError:false, elementType:'inputCustom', 
            disabled: true, currentValue:props.datosSolicitudExtranjero.segundoApellidoMadre||"", initialRequiredLength: 0, finalRequiredLength: 30,
        },        
        email: {
            idelement: "email", value:props.datosSolicitudExtranjero.correo||"", label: "Correo ", pattern:"^([\\wA-Z0-9._%+-]+@[\\wA-Z0-9.-]+\\.\\w{2,3})$", validators: ['requireds'], 
            errorMessages:['Máximo 125 caracteres, sin espacios al inicio y final'], isError:false, elementType:'input',
            currentValue:props.datosSolicitudExtranjero.correo||"", initialRequiredLength: 0, finalRequiredLength: 125
        },        
        profesion: {
            idelement: "profesion", value:props.datosSolicitudExtranjero.profesion, label: "Profesión *", pattern:"^([1-9-][0-9]*){1,1}$", validators: ['required'], 
            errorMessages:['Seleccione una Profesión'], isError:false, elementType:'autocompleteV2', list: [], position: props.datosSolicitudExtranjero.profesion-1 , 'showSelectAutoComplete': true,
            disabled: false, modified: false, currentValue:props.datosSolicitudExtranjero.profesion, focus: {ejecutar: true, function: setProfesiones}
        },        
    residenciaCiudadano:{
        idelement: "residenciaCiudadano",title:'UBICACIÓN GEOGRÁFICA POR RESIDENCIA DEL CIUDADANO', position:"center", value: "", currentValue:"", isError:false, elementType:'titleCustom',
        show: true,
    },
    extranjeroONacional:{
        idelement: "extranjeroONacional", value: props.datosSolicitudExtranjero.extranjeroONacional, label: "Seleccione el territorio en el que se encuentra:", isError:false, elementType:'radio', errorMessages:['Debe seleccionar una opción'], options : [ { value: "0", label: 'Extranjero' }, { value: "1", label: 'Nacional' }, ], 'disabled':false,
    },   
    pais: {
        idelement: "pais", value: (props.datosSolicitudExtranjero.pais?.id === undefined) ? null : props.datosSolicitudExtranjero.pais, 
        label: "Pais *", pattern:"^[1-9][0-9]*$", validators: ['required'], handler: obtenerEstadoDelPais, 
        errorMessages:['Seleccione el Pais'], isError:false, elementType:'autocompleteV2', list: [], position: props.datosSolicitudExtranjero.pais-2, 'showSelectAutoComplete': false,
        disabled: false, modified: false, focus: {ejecutar: true, function: obtenerPaises}
    },               
    estadoResidencia: {
        idelement: "estadoResidencia", value:props.datosSolicitudExtranjero.estadoResidencia, label: "Estado Residencia *", pattern:"^[1-9][0-9]*$", validators: ['required'],
        errorMessages:['Seleccione Estado Residencia'], isError:false, elementType:'autocompleteV2', list: [], handler: obtenerCiudadDelEstadoDelPais, position: props.datosSolicitudExtranjero.estadoResidencia-1, 'showSelectAutoComplete': false,
        disabled: false, modified: false, focus: {ejecutar: true, function: obtenerEstadoDelPais}
    },
    ciudadResidencia: {
        idelement: "ciudadResidencia", value: props.datosSolicitudExtranjero.ciudadResidencia, label: "Ciudad Residencia *", pattern:"^[1-9][0-9]*$", validators: ['required'], 
        errorMessages:['Seleccione Ciudad Residencia'], isError:false, elementType:'autocompleteV2', list: [],'showSelectAutoComplete': false,
        position: props.datosSolicitudExtranjero.posicionCiudad, disabled: false, modified: false, focus: {ejecutar: true, function: obtenerCiudadDelEstadoDelPais}
    },        
    departamentoResidencia: {
        idelement: "departamentoResidencia", value:props.datosSolicitudExtranjero.departamentoResidencia , label: "Departamento Residencia *", pattern:"^[1-9][0-9]*$", validators: ['required'],
        errorMessages:['Seleccione el Departamento Residencia'], isError:false, elementType:'autocompleteV2', list: [], handler: obtenerMuninipiosResidencia, position:props.datosSolicitudExtranjero.departamentoResidencia-1, 'showSelectAutoComplete': true,
        disabled:false, modified: false, focus: {ejecutar: true, function: obtenerDepartamentos}
        // errorMessages:['Seleccione el Departamento Residencia'], isError:false, elementType:'autocompleteV2', list: [], handler: obtenerMuninipiosResidencia, position:props.datosSolicitudExtranjero.departamentoResidencia-1, 'showSelectAutoComplete': true,
    },
    municipioResidencia: {
        idelement: "municipioResidencia", value: props.datosSolicitudExtranjero.municipioResidencia, label: "Municipio Residencia *", pattern:"^[1-9][0-9]*$", validators: ['required'],
        errorMessages:['Seleccione el Municipio Residencia'], isError:false, elementType:'autocompleteV2', list: [], handler: setComunidad, position:props.datosSolicitudExtranjero.municipioResidencia-1, 
        'showSelectAutoComplete': true, disabled:false, modified: false , focus: {ejecutar: true, function: obtenerMuninipiosResidencia}
    },        
    comunidadResidencia: {
        idelement: "comunidadResidencia", value: props.datosSolicitudExtranjero.comunidadResidencia, label: "Comunidad Residencia *", pattern:"^[1-9][0-9]*$", validators: ['required'], 
        errorMessages:['Seleccione la Comunidad Residencia'], isError:false, elementType:'autocompleteV2', list: [], position: props.datosSolicitudExtranjero.positionComunidad,
        'showSelectAutoComplete': true, disabled:false, modified: false, focus: {ejecutar: true, function: setComunidad}, handler: ObtenerCodigoGeolectoralSeleccionado,
    },
    direccionResidencia: {
        idelement: "direccionResidencia",  value:props.datosSolicitudExtranjero.direccionResidencia||"", label: "Dirección Residencia *", 
        pattern:"^([\\w1-9_ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜ.,!¡\"#$%&/()=¿?'@*-][\\w1-9_ ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜ.,!¡\"#$%&/()=¿?'@*-]*[\\w1-9_ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜ.,!¡\"#$%&/()=¿?'@*-])$",         
        validators: ['required'], errorMessages:['Ingrese Dirección Residencia, Máximo 50 caracteres'], isError:false, elementType:'input', showInputControl: true,         
    },
    nocasalote: {
        idelement: "nocasalote",  value:props.datosSolicitudExtranjero.nocasalote||"", label: "No. Casa/Lote", pattern:"[-\\w_.\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()]+(?: +[-\\w_.\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()]+)*",
        validators: ['requireds'], errorMessages:['No. Casa/Lote - Máximo 10 caracteres, sin espacios al inicio y final'], isError:false, elementType:'input', showInputControl: true, initialRequiredLength: 0, finalRequiredLength: 10,
    },
    zona: {
        idelement: "zona",  value:props.datosSolicitudExtranjero.zona||"", label: "Zona", pattern:"", validators: ['requireds'], errorMessages:['Zona - Máximo 2 caracteres'], 
        isError:false, elementType:'input', showInputControl: true, initialRequiredLength: 0, finalRequiredLength: 2,
    }, 
    codigoGeoelectoral:{
        idelement: "codigoGeoelectoral", title:'Código GeoElectoral', position:"center", value: "", currentValue:"", isError:false, elementType:'titleCustom', show: true,
    },
        departamentoCodigoGeoelectoral:{
            idelement: "departamentoCodigoGeoelectoral", position:"center",  isError:false, elementType:'labelWithTitleAndSubtitle',
            value: {title: 'Departamento', value:''}, currentValue:"", show: true,
        },
        municipioCodigoGeoelectoral:{
            idelement: "municipioCodigoGeoelectoral", position:"center",  isError:false, elementType:'labelWithTitleAndSubtitle',
            value: {title: 'Municipio', value:''}, currentValue:"", show: true,
        },
        comunidadCodigoGeoelectoral:{
            idelement: "comunidadCodigoGeoelectoral", position:"center",  isError:false, elementType:'labelWithTitleAndSubtitle',
            value: {title: 'Comunidad', value:''}, currentValue:"", show: true,
        },
        centroVotacionCodigoGeoelectoral:{
            idelement: "centroVotacionCodigoGeoelectoral", position:"center",  isError:false, elementType:'labelWithTitleAndSubtitle',
            value: {title: 'Centro de Votación', value:''}, currentValue:"", show: true,
        },    
    // titleDescapacidades:{
    //     idelement: "titleDescapacidades",title:'Discapacidades', position:"center", value: "", currentValue:"", isError:false, elementType:'titleCustom'
    // },
    //     discapacidad: {
    //         idelement: "discapacidad", value: null, label: "Seleccione Discapacidad", pattern:"", validators: ['requireds'],
    //         errorMessages:['Seleccione Discapacidad'], isError:false, elementType:'autocompleteV2', list: [], 
    //         handler: funcionObtenerTodasLasClasificacionesDeDiscapacidades,
    //         disabled: false, modified: false, focus: {ejecutar: true, function: funcionObtenerTodasLasDiscapacidades}
    //     },    
    //     clasificacionDiscapacidad: { 
    //         idelement: "clasificacionDiscapacidad", options:[], value: [], placeholder: "Seleccione clasificación", label: 'Seleccione Clasificación', validators: ['required'], 
    //         errorMessages:['Seleccione Clasificación'], isError:false, elementType:'autoCompleteCheckbox', 
    //         handler: funcionListarDiscapacidadesSeleccionadas,
    //     },
    //     titleDiscapacidades:{ 
    //         idelement: "titleDiscapacidades", title:'Discapacidades asignadas', position:"left", value: "", currentValue:"", isError:false, elementType:'customTitle'
    //     },        
    //     showList: { idelement: "showList", icon: <PlayArrow />,  data: [], elementType:'list', value: "",},
    titleObservacion:{
        idelement: "titleObservacion",title:'Observaciones', position:"center", value: "", currentValue:"", isError:false, elementType:'titleCustom', show: true,
    },    
        observaciones: {
            idelement: "observaciones",  value:props.datosSolicitudExtranjero.observaciones||"", label: "Observación", 
            // pattern:"^([[\\w1-9_ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜ.,!¡\"#$%&/()=¿?'@*-][\\w1-9_ ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜ.,!¡\"#$%&/()=¿?'@*-]{0,1024}]*[\\w1-9_ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜ.,!¡\"#$%&/()=¿?'@*-])$", 
            pattern:"",
            minWidth: 900,
            validators: ['requireds'], errorMessages:['Observaciones - Máximo 1024 caracteres'], isError:false, elementType:'textareaV2', showInputControl: true, maxLength: 1024
        },    
    });
    
    const handClose = (event, reason) =>{
        if (reason === 'clickaway') {return ;}
        setOpen(false)
    }

    const validarDatosRequeridos = (data) =>{        
        newErrors =[]
        Object.keys(elements).forEach((element, key, _array) =>{
            if(elements[element].validators !== undefined){
                if(elements[element]?.validators[0] === 'required'){
                    if(elements[element].idelement === 'departamentoVecindad' || elements[element].idelement === 'municipioVecindad' 
                        || elements[element].idelement === 'departamentoNacimiento' || elements[element].idelement === 'municipioNacimiento' || elements[element].idelement === 'profesion'
                    ){
                        if(elements[element].value?.id === undefined || elements[element].value?.id === null || elements[element].value?.id === ''){
                            newErrors.push({name: elements[element].label, value: elements[element].value})
                        }
                    } 
                    else if(elements[element].idelement === 'genero' || elements[element].idelement === 'alfabetismo' ||elements[element].idelement === 'noVidente'){
                        if(elements[element].value === undefined || elements[element].value === null || elements[element].value === ''){
                            newErrors.push({name: elements[element].label, value: elements[element].value})
                        }
                    } 
                    else if(elements.extranjeroONacional.value === '0') {
                        if(elements[element].idelement === 'pais' || elements[element].idelement === 'estadoResidencia' || elements[element].idelement === 'ciudadResidencia' ){
                            if(elements[element].value?.id === undefined || elements[element].value?.id === null || elements[element].value?.id === ''){
                                newErrors.push({name: elements[element].label, value: elements[element].value})
                            }
                        }
                    }                    
                    else if(elements.extranjeroONacional.value === '1') {
                        if(elements[element].idelement === 'departamentoResidencia'|| elements[element].idelement === 'municipioResidencia' || elements[element].idelement === 'comunidadResidencia'){
                            if(elements[element].value?.id === undefined || elements[element].value?.id === null || elements[element].value?.id === ''){
                                newErrors.push({name: elements[element].label, value: elements[element].value})
                            }
                        }
                    }
                    else if(elements[element].value === null || elements[element].value === undefined || elements[element].value === '' ) {
                        newErrors.push({name: elements[element].label, value: elements[element].value})
                    }
                }
            }
        })
        if(newErrors.length>0) return setErrors({error: newErrors, open: true});
        else return setErrors({error: [], open: false});    
    }
    const generarSolicitudEmpadronamiento = () =>{
        if(elements.municipioVecindad.value?.id === 0) elements.municipioVecindad.value.id = props.datosSolicitudExtranjero.municipioVecindadDPI?.id;
        if(elements.municipioNacimiento.value?.id === 0) elements.municipioNacimiento.value.id = props.datosSolicitudExtranjero.municipioNacimiento?.id;
        if(elements.municipioResidencia.value?.id === 0) elements.municipioResidencia.value.id = props.datosSolicitudExtranjero.municipioResidencia?.id;

        let datosSolicitudEmpadronamiento = { objetoInconsistencia:{},
            cui: elements.cui.value, serie: elements.serie.value, fechaEmisionDPI: elements.fechaEmisionDPI.value,
            departamentoVecindad: (props.datosSolicitudExtranjero?.paisDeResidencia?.id === 320 || props.datosSolicitudExtranjero?.paisDeResidencia?.id === null || props.datosSolicitudExtranjero?.paisDeResidencia?.id === undefined) ? elements.departamentoVecindad.value?.id : elements.departamentoVecindad.value?.id,
            municipioVecindad:    (props.datosSolicitudExtranjero?.paisDeResidencia?.id === 320 || props.datosSolicitudExtranjero?.paisDeResidencia?.id === null || props.datosSolicitudExtranjero?.paisDeResidencia?.id === undefined) ? elements.municipioVecindad.value?.id : elements.municipioVecindad.value?.id,
            primerNombre: elements.primerNombre.value.toUpperCase(), segundoNombre: elements.segundoNombre.value, primerApellido: elements.primerApellido.value.toUpperCase(), segundoApellido: elements.segundoApellido.value, tercerApellido: elements.tercerApellido.value,
            genero: elements.genero.value, alfabetismo: elements.alfabetismo.value, fechaNacimiento: elements.fechaNacimiento.value,
            departamentoNacimiento: elements.departamentoNacimiento.value.id, municipioNacimiento: elements.municipioNacimiento.value.id,
            departamentoNacimientoDPI: elements.departamentoNacimiento.value.id, municipioNacimientoDPI: elements.municipioNacimiento.value.id,
            nroLibroNacimiento: elements.nroLibroNacimiento.value, nroFolioNacimiento: elements.nroFolioNacimiento.value, nroPartidaNacimiento: elements.nroPartidaNacimiento.value, telefono: elements.telefono.value,
            primerNombrePadre: elements.primerNombrePadre.value, segundoNombrePadre: elements.segundoNombrePadre.value, primerApellidoPadre: elements.primerApellidoPadre.value, segundoApellidoPadre: elements.segundoApellidoPadre.value,
            primerNombreMadre: elements.primerNombreMadre.value, segundoNombreMadre: elements.segundoNombreMadre.value, primerApellidoMadre: elements.primerApellidoMadre.value, segundoApellidoMadre: elements.segundoApellidoMadre.value,
            email: elements.email.value, profesion: elements.profesion.value?.id, direccion: elements.direccionResidencia.value, numeroCasa: elements.nocasalote.value, numeroZona: elements.zona.value, departamentoResidencia: elements.departamentoResidencia.value?.id || "", municipioResidencia: elements.municipioResidencia.value?.id || "", comunidadResidencia: elements.comunidadResidencia.value?.id || "",
            centroVotacion: cenVotacion, nroBoleta:props.nroBoleta, paisResidencia: elements.pais.value?.id || null, estadoResidencia: elements.estadoResidencia.value?.id || null, ciudadResidencia: elements.ciudadResidencia.value?.id || null,
            numeroLibroNacimientoDpi: elements.nroLibroNacimiento.value, numeroFolioNacimientoDpi: elements.nroFolioNacimiento.value, numeroPartidaNacimientoDpi: elements.nroPartidaNacimiento.value,
            ordenCedula:'', registroCedula:'', departamentoCedula:'', municipioCedula:'', fechaAsientoNacimiento: new Date(props.datosSolicitudExtranjero.fechaAsientoNacimiento), fechaNacionalizacion:'',
            fotografiaBase64: props.datoIdentidadFotoIngresada, observaciones: elements.observaciones.value ? elements.observaciones.value.trim() : '',
            noVidente: (!props.datosSolicitudExtranjero.nroBoleta) ? 
                (Number(elements.noVidente.value) === 1 ) ? 
                    0 
                    : 1 
            : (elements.noVidente.value) ,
        }

        if(elements.extranjeroONacional.value === '0') datosSolicitudEmpadronamiento.origenSolicitud = 3;
        else datosSolicitudEmpadronamiento.origenSolicitud = 3
        if(elements.direccionResidencia.value === false) datosSolicitudEmpadronamiento.direccion = '';
        else datosSolicitudEmpadronamiento.direccion = elements.direccionResidencia.value.toUpperCase();
        // segundo nombre y apellido del ciudadano
        if(elements.segundoNombre.value === null) datosSolicitudEmpadronamiento.segundoNombre = '';
        else datosSolicitudEmpadronamiento.segundoNombre = elements.segundoNombre.value.toUpperCase();
        if(elements.segundoApellido.value === null) datosSolicitudEmpadronamiento.segundoApellido = '';
        else datosSolicitudEmpadronamiento.segundoApellido = elements.segundoApellido.value.toUpperCase();
        if(elements.tercerApellido.value === null) datosSolicitudEmpadronamiento.tercerApellido = '';
        else datosSolicitudEmpadronamiento.tercerApellido = elements.tercerApellido.value.toUpperCase();
        // nombre del padre
        if(elements.primerNombrePadre.value === null) datosSolicitudEmpadronamiento.primerNombrePadre = '';
        else datosSolicitudEmpadronamiento.primerNombrePadre = elements.primerNombrePadre.value.toUpperCase();
        if(elements.segundoNombrePadre.value === null) datosSolicitudEmpadronamiento.segundoNombrePadre = '';
        else datosSolicitudEmpadronamiento.segundoNombrePadre = elements.segundoNombrePadre.value.toUpperCase();
        if(elements.primerApellidoPadre.value === null) datosSolicitudEmpadronamiento.primerApellidoPadre = '';
        else datosSolicitudEmpadronamiento.primerApellidoPadre = elements.primerApellidoPadre.value.toUpperCase();
        if(elements.segundoApellidoPadre.value === null) datosSolicitudEmpadronamiento.segundoApellidoPadre = '';
        else datosSolicitudEmpadronamiento.segundoApellidoPadre = elements.segundoApellidoPadre.value.toUpperCase();
        // nombre de la madre
        if(elements.primerNombreMadre.value === null) datosSolicitudEmpadronamiento.primerNombreMadre = '';
        else datosSolicitudEmpadronamiento.primerNombreMadre = elements.primerNombreMadre.value.toUpperCase();
        if(elements.segundoNombreMadre.value === null) datosSolicitudEmpadronamiento.segundoNombreMadre = '';
        else datosSolicitudEmpadronamiento.segundoNombreMadre = elements.segundoNombreMadre.value.toUpperCase();
        if(elements.primerApellidoMadre.value === null) datosSolicitudEmpadronamiento.primerApellidoMadre = '';
        else datosSolicitudEmpadronamiento.primerApellidoMadre = elements.primerApellidoMadre.value.toUpperCase();
        if(elements.segundoApellidoMadre.value === null) datosSolicitudEmpadronamiento.segundoApellidoMadre = '';
        else datosSolicitudEmpadronamiento.segundoApellidoMadre = elements.segundoApellidoMadre.value.toUpperCase();

        if(elements.email.value === null) datosSolicitudEmpadronamiento.email = null;
        else datosSolicitudEmpadronamiento.email = elements.email.value.toUpperCase();

        //objetoDiscapacidad
        // let getClasificacionDiscapacidad = elements.clasificacionDiscapacidad.value
        // let getClasificacionSeleccionadas = [];

        // for (let index = 0; index < getClasificacionDiscapacidad.length; index++) {
        //     getClasificacionSeleccionadas.push({idSubDiscapacidad: getClasificacionDiscapacidad[index].id , idDiscapacidad: getClasificacionDiscapacidad[index].Discapacidad?.id})
        // }
        // datosSolicitudEmpadronamiento.objetoDiscapacidad = getClasificacionSeleccionadas
        return saveData = datosSolicitudEmpadronamiento;
    }

    const generarSolicitudActualizacion = () =>{
        if(elements.municipioVecindad.value?.id === 0) elements.municipioVecindad.value.id = props.datosSolicitudExtranjero.municipioVecindadDPI?.id;
        if(elements.municipioNacimiento.value?.id === 0) elements.municipioNacimiento.value.id = props.datosSolicitudExtranjero.municipioNacimiento?.id;
        if(elements.municipioResidencia.value?.id === 0) elements.municipioResidencia.value.id = props.datosSolicitudExtranjero.municipioResidencia?.id;
        if(elements.comunidadResidencia.value?.id === 0) elements.comunidadResidencia.value.id = props.datosSolicitudExtranjero.comunidadResidencia?.id;

        let datosSolicitudActualizacion = { objetoInconsistencia:{},
            cui: elements.cui.value, serie: elements.serie.value, fechaEmisionDPI: elements.fechaEmisionDPI.value, 
            departamentoVecindad: (props.datosSolicitudExtranjero?.paisDeResidencia?.id === 320 || props.datosSolicitudExtranjero?.paisDeResidencia?.id === null || props.datosSolicitudExtranjero?.paisDeResidencia?.id === undefined) ? elements.departamentoVecindad.value?.id : elements.departamentoVecindad.value?.id,
            municipioVecindad:    (props.datosSolicitudExtranjero?.paisDeResidencia?.id === 320 || props.datosSolicitudExtranjero?.paisDeResidencia?.id === null || props.datosSolicitudExtranjero?.paisDeResidencia?.id === undefined) ? elements.municipioVecindad.value?.id : elements.municipioVecindad.value?.id,
            primerNombre: elements.primerNombre.value.toUpperCase(), segundoNombre: elements.segundoNombre.value, primerApellido: elements.primerApellido.value.toUpperCase(), segundoApellido: elements.segundoApellido.value, tercerApellido: elements.tercerApellido.value, genero: elements.genero.value, alfabetismo: elements.alfabetismo.value, fechaNacimiento: elements.fechaNacimiento.value, 
            departamentoNacimiento: elements.departamentoNacimiento.value.id, municipioNacimiento: elements.municipioNacimiento.value.id,
            departamentoNacimientoDPI: elements.departamentoNacimiento.value.id, municipioNacimientoDPI: elements.municipioNacimiento.value.id, 
            nroLibroNacimiento: elements.nroLibroNacimiento.value, nroFolioNacimiento: elements.nroFolioNacimiento.value, nroPartidaNacimiento: elements.nroPartidaNacimiento.value, telefono: elements.telefono.value,
            primerNombrePadre: elements.primerNombrePadre.value, segundoNombrePadre: elements.segundoNombrePadre.value, primerApellidoPadre: elements.primerApellidoPadre.value, segundoApellidoPadre: elements.segundoApellidoPadre.value,
            primerNombreMadre: elements.primerNombreMadre.value, segundoNombreMadre: elements.segundoNombreMadre.value, primerApellidoMadre: elements.primerApellidoMadre.value, segundoApellidoMadre: elements.segundoApellidoMadre.value,
            email: elements.email.value, profesion: elements.profesion.value?.id, direccion: elements.direccionResidencia.value, numeroCasa: elements.nocasalote.value, numeroZona: elements.zona.value, departamentoResidencia: elements.departamentoResidencia.value?.id || "", municipioResidencia: elements.municipioResidencia.value?.id || "", comunidadResidencia: elements.comunidadResidencia.value?.id, 
            centroVotacion: cenVotacion, nroBoleta:props.datosSolicitudExtranjero.nroBoleta, paisResidencia: elements.pais.value?.id || null, estadoResidencia: elements.estadoResidencia.value?.id || null, ciudadResidencia: elements.ciudadResidencia.value?.id || null,
            numeroLibroNacimientoDpi:elements.nroLibroNacimiento.value, numeroFolioNacimientoDpi: elements.nroFolioNacimiento.value, numeroPartidaNacimientoDpi: elements.nroPartidaNacimiento.value, fechaAsientoNacimiento: new Date(props.datosSolicitudExtranjero.fechaAsientoNacimiento),
            ordenCedula:'', registroCedula:'', departamentoCedula:'', municipioCedula:'', fechaNacionalizacion:'', fotografiaBase64: "", observaciones: elements.observaciones.value ? elements.observaciones.value.trim() : '',
            noVidente: (!props.datosSolicitudExtranjero.nroBoleta) ? 
            (Number(elements.noVidente.value) === 1 ) ? 
                0 
                : 1 
        : (elements.noVidente.value) ,
        }
        // fotografiaBase64: props.datoIdentidadFotoIngresada,
        if(elements.extranjeroONacional.value === '0') datosSolicitudActualizacion.origenSolicitud = 3;
        else datosSolicitudActualizacion.origenSolicitud = 3
        if(elements.direccionResidencia.value === false) datosSolicitudActualizacion.direccion = '';
        else datosSolicitudActualizacion.direccion = elements.direccionResidencia.value.toUpperCase();
        // segundo nombre y apellido del ciudadano
        if(elements.segundoNombre.value === null) datosSolicitudActualizacion.segundoNombre = '';
        else datosSolicitudActualizacion.segundoNombre = elements.segundoNombre.value.toUpperCase();
        if(elements.segundoApellido.value === null) datosSolicitudActualizacion.segundoApellido = '';
        else datosSolicitudActualizacion.segundoApellido = elements.segundoApellido.value.toUpperCase();
        if(elements.tercerApellido.value === null) datosSolicitudActualizacion.tercerApellido = '';
        else datosSolicitudActualizacion.tercerApellido = elements.tercerApellido.value.toUpperCase();
        // nombre del padre
        if(elements.primerNombrePadre.value === null) datosSolicitudActualizacion.primerNombrePadre = '';
        else datosSolicitudActualizacion.primerNombrePadre = elements.primerNombrePadre.value.toUpperCase();
        if(elements.segundoNombrePadre.value === null) datosSolicitudActualizacion.segundoNombrePadre = '';
        else datosSolicitudActualizacion.segundoNombrePadre = elements.segundoNombrePadre.value.toUpperCase();
        if(elements.primerApellidoPadre.value === null) datosSolicitudActualizacion.primerApellidoPadre = '';
        else datosSolicitudActualizacion.primerApellidoPadre = elements.primerApellidoPadre.value.toUpperCase();
        if(elements.segundoApellidoPadre.value === null) datosSolicitudActualizacion.segundoApellidoPadre = '';
        else datosSolicitudActualizacion.segundoApellidoPadre = elements.segundoApellidoPadre.value.toUpperCase();
        // nombre de la madre
        if(elements.primerNombreMadre.value === null) datosSolicitudActualizacion.primerNombreMadre = '';
        else datosSolicitudActualizacion.primerNombreMadre = elements.primerNombreMadre.value.toUpperCase();
        if(elements.segundoNombreMadre.value === null) datosSolicitudActualizacion.segundoNombreMadre = '';
        else datosSolicitudActualizacion.segundoNombreMadre = elements.segundoNombreMadre.value.toUpperCase();
        if(elements.primerApellidoMadre.value === null) datosSolicitudActualizacion.primerApellidoMadre = '';
        else datosSolicitudActualizacion.primerApellidoMadre = elements.primerApellidoMadre.value.toUpperCase();
        if(elements.segundoApellidoMadre.value === null) datosSolicitudActualizacion.segundoApellidoMadre = '';
        else datosSolicitudActualizacion.segundoApellidoMadre = elements.segundoApellidoMadre.value.toUpperCase();        

        if(elements.email.value === null) datosSolicitudActualizacion.email = '';
        else datosSolicitudActualizacion.email = elements.email.value.toUpperCase();    

        //objetoDiscapacidad
        // let getClasificacionDiscapacidad = elements.clasificacionDiscapacidad.value
        // let getClasificacionSeleccionadas = [];

        // for (let index = 0; index < getClasificacionDiscapacidad.length; index++) {
        //     getClasificacionSeleccionadas.push({idSubDiscapacidad: getClasificacionDiscapacidad[index].id , idDiscapacidad: getClasificacionDiscapacidad[index].Discapacidad?.id})
        // }
        // datosSolicitudActualizacion.objetoDiscapacidad = getClasificacionSeleccionadas

        return saveData = datosSolicitudActualizacion
    }

    //obtenemos los valores de inconsistencias
    const obtenerInconsistencias = () =>{
        var inconsistencias = elements        
        Object.keys(inconsistencias).forEach((element, key, _array) =>{
            if(inconsistencias[element].elementType === 'date'){
                if(inconsistencias[element].value.getTime() != inconsistencias[element].currentValue.getTime()){
                    saveData.objetoInconsistencia[inconsistencias[element].idelement] = inconsistencias[element].currentValue
                }
            }
            else if(inconsistencias[element].idelement === 'departamentoVecindad' || inconsistencias[element].idelement === 'municipioVecindad'
            || inconsistencias[element].idelement === 'departamentoNacimiento' || inconsistencias[element].idelement === 'municipioNacimiento'
            ){
                if(inconsistencias[element].value?.id != inconsistencias[element].currentValue?.id){
                    saveData.objetoInconsistencia[inconsistencias[element].idelement] = inconsistencias[element].currentValue?.id
                }
            }
            else if(inconsistencias[element].value != inconsistencias[element].currentValue 
                && inconsistencias[element].idelement !== 'departamentoResidencia' && inconsistencias[element].idelement !== 'municipioResidencia' && inconsistencias[element].idelement !== 'comunidadResidencia'
                && inconsistencias[element].idelement !== 'direccionResidencia' && inconsistencias[element].idelement !== 'nocasalote' && inconsistencias[element].idelement !== 'zona'
                && inconsistencias[element].idelement !== 'observaciones' && inconsistencias[element].idelement !== 'extranjeroONacional' && inconsistencias[element].idelement !== 'pais'
                && inconsistencias[element].idelement !== 'estadoResidencia' && inconsistencias[element].idelement !== 'ciudadResidencia' && inconsistencias[element].idelement !== 'alfabetismo'
                && inconsistencias[element].idelement !== 'noVidente' && inconsistencias[element].idelement !== 'telefono' && inconsistencias[element].idelement !== 'email'
                && inconsistencias[element].idelement !== 'profesion' && inconsistencias[element].idelement !== 'departamentoCodigoGeoelectoral' && inconsistencias[element].idelement !== 'municipioCodigoGeoelectoral'
                && inconsistencias[element].idelement !== 'comunidadCodigoGeoelectoral' && inconsistencias[element].idelement !== 'centroVotacionCodigoGeoelectoral' && inconsistencias[element].idelement !== 'municipioCodigoGeoelectoral'
                && inconsistencias[element].idelement !== 'nroBoleta' && inconsistencias[element].idelement !== 'estatusPadron' && inconsistencias[element].idelement !== 'nombreEstatusPadron'
                && inconsistencias[element].idelement !== 'clasificacionDiscapacidad' && inconsistencias[element].idelement !== 'showList' && inconsistencias[element].idelement !== 'discapacidad'
            ){
                saveData.objetoInconsistencia[inconsistencias[element].idelement] = inconsistencias[element].currentValue
            }
        })                            
    }
    const validarDatosResidenciaElectoralNacional = () =>{
        if(elements.extranjeroONacional.value === '1'){
            if((elements.departamentoResidencia.value?.id === null && elements.departamentoResidencia.value.name === '') || (elements.departamentoResidencia.value?.id === undefined && elements.departamentoResidencia.value.name === '')){
                elements.departamentoResidencia.value = null
                showMessagePersonalizedPosition('warning', 'Advertencia' ,'Por favor seleccione departamento de residencia.')
                return true;
            }
            if((elements.municipioResidencia.value?.id === null && elements.municipioResidencia.value.name === '') || (elements.municipioResidencia.value?.id === undefined && elements.municipioResidencia.value.name === '')){
                elements.municipioResidencia.value = null
                showMessagePersonalizedPosition('warning', 'Advertencia' ,'Por favor seleccione municipio de residencia.')
                return true;
            }
            if((elements.comunidadResidencia.value?.id === null && elements.comunidadResidencia.value.name === '') || (elements.comunidadResidencia.value?.id === undefined && elements.comunidadResidencia.value.name === '')){
                elements.comunidadResidencia.value = null
                showMessagePersonalizedPosition('warning', 'Advertencia' ,'Por favor seleccione comunidad de residencia.')
                return true;
            }
        }
    }    
    const validarDatosResidenciaElectoralExtranjero = () =>{
        if(elements.extranjeroONacional.value === '0'){
            if((elements.pais.value?.id === null && elements.pais.value.name === '') || (elements.pais.value?.id === undefined && elements.pais.value.name === '')){
                elements.pais.value = null
                showMessagePersonalizedPosition('warning', 'Advertencia' ,'Por favor seleccione país de residencia.')
                return true;
            }
            if((elements.estadoResidencia.value?.id === null && elements.estadoResidencia.value.name === '') || (elements.estadoResidencia.value?.id === undefined && elements.estadoResidencia.value.name === '')){
                elements.estadoResidencia.value = null
                showMessagePersonalizedPosition('warning', 'Advertencia' ,'Por favor seleccione estado de residencia.')
                return true;
            }
            if((elements.ciudadResidencia.value?.id === null && elements.ciudadResidencia.value.name === '') || (elements.ciudadResidencia.value?.id === undefined && elements.ciudadResidencia.value.name === '')){
                elements.ciudadResidencia.value = null
                showMessagePersonalizedPosition('warning', 'Advertencia' ,'Por favor seleccione ciudad de residencia.')
                return true;
            }
        }
    }    
    //consulto la base de datos y envio la solicitud que se creo
    const getUserData = async (idSolicitud, cui, userName) =>{
        try{
            const hasPermission = await ApiServices.userSecurity.hasPermission('solicitudesDeEmpadronamiento','list');    
            if (hasPermission.error){
            }else{
                ApiServices.solicitudesDeEmpadronamiento.searchCriteria.clear();
                ApiServices.solicitudesDeEmpadronamiento.searchCriteria.setOperator("and");
                ApiServices.solicitudesDeEmpadronamiento.searchCriteria.addEquals("datosSolicitudEmpadronamiento.statusSolicitud", 0);  
                ApiServices.solicitudesDeEmpadronamiento.searchCriteria.NotEquals("datosSolicitudEmpadronamiento.nombreOrigen", 4);  
                
                // ApiServices.solicitudesDeEmpadronamiento.searchCriteria.addContains("idSolicitud", props.idSolicitudGeneradoNacional);
                ApiServices.solicitudesDeEmpadronamiento.searchCriteria.addContains("idSolicitud", idSolicitud);
                ApiServices.solicitudesDeEmpadronamiento.searchCriteria.addContains("datosDpiSolicitudEmpadronamiento.cui", cui);
                ApiServices.solicitudesDeEmpadronamiento.searchCriteria.addContains("usuarioCreador", userName);
                const response =  await ApiServices.solicitudesDeEmpadronamiento.pageRegister(0, 10);
                if (response.error) {
                    showMessagePersonalizedPosition('warning','¡Advertencia!', response?.error?.message,'center')
                } else {
                    if(props.ejecutar)
                        props.AbrirModalProcesarSolicitudExtranjero(response.data.content[0])
                    else
                        dispatch(allActions.setDatosSolicitudExtranjero({data: response.data.content[0], open: true}));
                };
            }
        }catch(exception){
            showMessagePersonalizedPosition('error', '¡Advertencia!', "Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.", 'center')
        }
    }    
    // Diego
    // Aqui se hace la solicitud de inscripcion o actualizacion. Aqui se tendria que agregar el id de la cita de empadronamiento.
    const nextStep = async () => {
      ObtenerNombreComunidad();
      setLoadingMessage({loading: true, title:'Generando solicitud ...'})

      if (props.nroBoleta != "") generarSolicitudActualizacion();
      else generarSolicitudEmpadronamiento();
      obtenerInconsistencias()

      if (validarDatosResidenciaElectoralNacional()) {
        setLoadingMessage({loading: false, title:''})
        return;
      }
      
      if (validarDatosResidenciaElectoralExtranjero()) {
        setLoadingMessage({loading: false, title:''})
        return;
      }
      
      validarDatosRequeridos(saveData)
      
      if(newErrors.length>0) {
        setLoadingMessage({loading: false, title:''})
        return ;
      }
      try {
          const response = await ApiServices.crearSolicitudesDeEmpadronamiento.delegacionYPortalWeb(saveData);
        if (response.error) {
            showMessagePersonalizedPosition('warning','¡Advertencia!', response?.error?.message,'center')
        } else {
            showMessagePersonalizedPosition('success', '¡BIEN!',response.data.message, 'center')
            getUserData(response.data.idSolicitud, saveData?.cui, props.currentUser.userName)
            let datosSolicitudGeneradoNancional = {datosSolicitudGeneradoNancional:{cui: saveData?.cui, usuario: props.currentUser.userName}}
            dispatch(allActions.solicitudDatosGenerado(datosSolicitudGeneradoNancional))
            props.SOLICITUD_EMPADRONAMIENTO_SET_ID_SOLICITUD_GENERADO(response.data.idSolicitud);
            props.SOLICITUD_EMPADRONAMIENTO_EXTRANJERO_SET_STEP(0);
            // props.actualizarTabla();
            props.cerrarDialogo();
            // history.push("/generarSolicitudDeDelegacion",{})
            // props.ObtenerTotalDeSolicitudesPendientesDeRealizar()
        }
      } catch (exception) {
          showMessagePersonalizedPosition('error', '¡Advertencia!', "Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.", 'center')
      }
      setLoadingMessage({loading: false, title:''})
    };
    const beforeStep=()=>{
        validarIdentidad(props.datosSolicitudExtranjero.dpi)
        props.SOLICITUD_EMPADRONAMIENTO_EXTRANJERO_SET_STEP(props.step-1);    
    };              

    const AbrirDialogoRechazarPorCasoEspecial = () => {
        setOpenRechazarProCasoEspecial(true)
    }
    const CerrarDialogoRechazarPorCasoEspecial = () => {
        setOpenRechazarProCasoEspecial(false)
    }

    const [buttonList,setButtonList]= React.useState({
        "save":{"label":"Siguiente","icon": <NavigateNext />,"callback":nextStep, disabled: false, "loading":false, "size":"medium", "background":"linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)", "border":"0px", "borderRadius":"3", "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px",
        },
        // "saveSpecialCase":{"label":"Caso Especial","icon": <NavigateNext />,"callback":AbrirDialogoRechazarPorCasoEspecial,"loading":false, "size":"medium", "background":"linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)", "border":"0px", "borderRadius":"3", "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px",
        // }, 
    });    
    
    const funcionObtenerEstadoEnElPadron = (status) =>{
        buttonList.save.disabled = status;
    }

    useEffect(() => {
        cenVotacion = props.datosSolicitudExtranjero.cenVotacionId
        elements.noVidente.list = ((props.datosSolicitudExtranjero.nroBoleta) ? ArrayNoVidentePadron : ArrayNoVidenteRenap); elements.alfabetismo.list = ArrayAlfabetismo; elements.genero.list = ArrayGenero;
        obtenerExtranjeros()
    },[])

    const obtenerExtranjeros = async () => {
        validateChangeInputRadio(elements['extranjeroONacional']);
        // await obtenerPaises(); 
        if(props.datosSolicitudExtranjero.extranjeroONacional == '0') {
            // event.target.value
            const event = {
                target: { value: props.datosSolicitudExtranjero.pais}
            }
            // await obtenerEstadoDelPais(event)
            const eventCity = {
                target: {value: props.datosSolicitudExtranjero.estadoResidencia}
            }
            // await obtenerCiudadDelEstadoDelPais(eventCity)
        }
    }

    const validarIdentidad = async (cui) => {

        if(!cui) {
            props.CLEAR_DATA_DATOS_IDENTIDAD();
            return;
        }
        
        try{
            const response =  await ApiServices.verificarSolicitudDeEmpadronamiento.validarIdentidad(cui);

            if(response.error){
                props.CLEAR_DATA_DATOS_IDENTIDAD();
            } else {
                props.SET_DATA_DATOS_IDENTIDAD(response?.data?.object)
            } 
        } catch(exception){
            props.CLEAR_DATA_DATOS_IDENTIDAD();
        }    
    }

    const validateChangeInputRadio = (element) => {
        let {departamentoResidencia = null, municipioResidencia = null, comunidadResidencia = null, direccionResidencia = '', nocasalote = '', zona = '',              
        pais= null, estadoResidencia = null, ciudadResidencia = null} = props.datosSolicitudExtranjero;
        if(pais?.id === undefined) pais = null;
        if(estadoResidencia?.id === undefined) estadoResidencia = null;
        if(ciudadResidencia?.id === undefined) ciudadResidencia = null;
        if(Number(element?.value) === 1) {
            changeValueAutoComplete([
               {id: "departamentoResidencia", show: true,  value: departamentoResidencia, isError: departamentoResidencia ? false : true, pattern:"^[1-9][0-9]*$", validators: ['required']}, 
               {id: "municipioResidencia", show: true,  value: municipioResidencia, isError: municipioResidencia ? false : true, pattern:"^[1-9][0-9]*$", validators: ['required']}, 
               {id: "comunidadResidencia", show: true,  value: comunidadResidencia, isError: comunidadResidencia ? false : true, pattern:"^[1-9][0-9]*$", validators: ['required']}, 
               {id: "direccionResidencia", show: true,  value: direccionResidencia, isError: direccionResidencia ? false : true, initialRequiredLength:2, finalRequiredLength: 50, validators: ['required'],
                    // pattern:"^([\\w_ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()][\\w_ .\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()]*[\\w_.\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()]){2,50}$"
                    pattern:"^([\\w1-9_ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜ.,!¡\"#$%&/()=¿?'@*-][\\w1-9_ ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜ.,!¡\"#$%&/()=¿?'@*-]*[\\w1-9_ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜ.,!¡\"#$%&/()=¿?'@*-])$", initialRequiredLength:2, finalRequiredLength: 50
                    // pattern:"^([[\\w1-9_ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜ.,!¡\"#$%&/()=¿?'@*-][\\w1-9_ ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜ.,!¡\"#$%&/()=¿?'@*-]]*[\\w1-9_ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜ.,!¡\"#$%&/()=¿?'@*-]){0,50}$"
                }, 
               {id: "nocasalote", show: true,  value: nocasalote, isError:  false, pattern:"^([-\\w_ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()][-\\w_ .\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()]*[-\\w_.\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()])$", initialRequiredLength: 0, finalRequiredLength: 10, validators: ['requireds']},
               {id: "zona", show: true,  value: zona, isError: false, pattern:"^[0-9]*$", validators: ['requireds']}, 
               {id: "pais", show: false,  value: null, isError: false, pattern:"", validators: ['requireds']}, 
               {id: "estadoResidencia", show: false,  value: null, isError: false, pattern:"", validators: ['requireds']}, 
               {id: "ciudadResidencia", show: false,  value: null, isError: false, pattern:"", validators: ['requireds']}, 
            ]);
        } else {
            changeValueAutoComplete([
                {id: "departamentoResidencia", show: false,  value: "", isError: false, pattern:"", validators: ['requireds']}, 
                {id: "municipioResidencia", show: false,  value: "", isError: false, pattern:"", validators: ['requireds']}, 
                {id: "comunidadResidencia", show: false,  value: "", isError: false, pattern:"", validators: ['requireds']}, 
                {id: "direccionResidencia", show: false,  value: "", isError: false, pattern:"", initialRequiredLength:0, validators: ['requireds']},  
                {id: "nocasalote", show: false,  value: "", isError: false, validators: ['requireds']}, 
                {id: "zona", show: false,  value: "", isError: false, validators: ['requireds']}, 
                {id: "pais", show: true,  value: pais, isError: pais ? false : true, pattern:"^[1-9][0-9]*$", validators: ['required']}, 
                {id: "estadoResidencia", show: true,  value: estadoResidencia, isError: estadoResidencia ? false : true, pattern:"^[1-9][0-9]*$", validators: ['required']}, 
                {id: "ciudadResidencia", show: true,  value: ciudadResidencia, isError: ciudadResidencia ? false : true, pattern:"^[1-9][0-9]*$", validators: ['required']}, 
             ]);
        }
        setElements({ ...elements});
    }

    const changeValueAutoComplete = (values) => {
      values.map( ({id, show, value, isError, pattern, initialRequiredLength, finalRequiredLength, validators}) => {
        elements[id].showSelectAutoComplete = show;
        elements[id].showInputControl = show;
        elements[id].isError = isError;
        elements[id].value = value;
        elements[id].pattern = pattern;
        elements[id].initialRequiredLength = initialRequiredLength;
        elements[id].finalRequiredLength = finalRequiredLength;
        elements[id].validators = validators;
      });
    }

    let AlertaAnalfabetaNoVidente = '';
    useEffect(() => {
        // let ArrayNoVidentePadron =[ {id:'0', name: 'Vidente'}, {id: '1', name: 'No vidente'}]
        // let ArrayNoVidenteRenap =[ {id:'0', name: 'No Vidente'}, {id: '1', name: 'Vidente'}]        
        if(props.datosSolicitudExtranjero.nroBoleta) {
            if(analfabeta.toString() === '0' && noVidente.toString() === '1' ) {
                setAlertaAnalfabetaNoVidente('Alerta: El ciudadano es analfabeta y no vidente, sí esta seguro de guardar los datos proceda a generar la solicitud');
            }else {
                setAlertaAnalfabetaNoVidente('');
            }
        }else{
            if(analfabeta.toString() === "0" && noVidente.toString() === "0" ){                
                setAlertaAnalfabetaNoVidente('Alerta: El ciudadano es analfabeta y no vidente, sí esta seguro de guardar los datos proceda a generar la solicitud');
            } else  {
                setAlertaAnalfabetaNoVidente('');

            }
        }
    },[analfabeta, noVidente])    

    const cerrarModalActualizarTabla  = () =>{
        props.actualizarTabla()
        props.cerrarDialogo()        
        CerrarDialogoRechazarPorCasoEspecial()
    }

    const handleCloseAlertaGeneral = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setOpenAlertaGeneral(false);
    };    
    // useEffect(() => {
    //     setComunidad();
    // }, [idDepartamentoResidencia])
    useEffect(() => {
        if(elements.municipioResidencia.value === null) {
            elements.comunidadResidencia.value = null
        };
    }, [elements.municipioResidencia.value])

    useEffect(() => {
        let newElements= Object. assign({}, elements); 
        if(newElements.departamentoResidencia.value?.id) newElements.departamentoCodigoGeoelectoral.value={title: 'Departamento', value: CentroDeVotacionParseada(elements.departamentoResidencia.value?.id, 2)};
        else newElements.departamentoCodigoGeoelectoral.value={title: 'Departamento', value: ''};
        if(newElements.municipioResidencia.value?.id) newElements.municipioCodigoGeoelectoral.value={title: 'Municipio', value: CentroDeVotacionParseada(elements.municipioResidencia.value?.id, 2)};
        else newElements.municipioCodigoGeoelectoral.value={title: 'Municipio', value: ''}
        // newElements.comunidadCodigoGeoelectoral.value={title: 'Comunidad', value: elements.comunidadResidencia.value?.id}
        // newElements.centroVotacionCodigoGeoelectoral.value={title: 'Centro de votación', value: elements.comunidadResidencia.value?.id}
        if(newElements.departamentoResidencia.value?.id === undefined) {
            newElements.comunidadCodigoGeoelectoral.value={title: 'Comunidad', value: ''}
            newElements.centroVotacionCodigoGeoelectoral.value={title: 'Centro de votación', value: ''}   
        }
        if(newElements.comunidadCodigoGeoelectoral.value?.value === undefined) {
            newElements.comunidadCodigoGeoelectoral.value={title: 'Comunidad', value: ''}
            newElements.centroVotacionCodigoGeoelectoral.value={title: 'Centro de votación', value: ''}    
        }
        if(newElements.comunidadResidencia.value?.id === undefined) {
            newElements.comunidadCodigoGeoelectoral.value={title: 'Comunidad', value: ''}
            newElements.centroVotacionCodigoGeoelectoral.value={title: 'Centro de votación', value: ''}    
        }
        if(newElements.departamentoResidencia.value?.id && elements.municipioResidencia.value?.id && elements.comunidadResidencia.value?.id){
            setComunidad()
            // let comunidad = {target:{value: elements.comunidadResidencia.value?.id}}
            // ObtenerCodigoGeolectoralSeleccionado(comunidad)
        }
        setElements(newElements);
    }, [elements.departamentoResidencia.value?.id, elements.municipioResidencia.value?.id, elements.comunidadResidencia.value?.id])

    return (
        <div className={classes.root}>
            <DialogLoadingMessage open={loadingStateCity.loading} title={loadingStateCity.title}/>
            <DialogLoadingMessage open={loadingMessage.loading} title={loadingMessage.title}/>
            <RechazarPorCasoEspecial open={openRechazarProCasoEspecial} handleClose={CerrarDialogoRechazarPorCasoEspecial} cerrar={cerrarModalActualizarTabla}/>
            <div className={classes.colorComponente}>
                <Grid>
                    <Grid className={classes.marginText} item xs={12}> 
                        <Form elements={elements} buttonList={buttonList} BotonRegresar={beforeStep} description={description}
                            validateChangeInputRadio={validateChangeInputRadio} alertWarningTitle={ alertaAnalfabetaNoVidente}/>
                    </Grid >
                </Grid >
            </div>   
            <MensajeAlerta type={mensaje.tipoError} content={mensaje.tipoMensaje} timeMessage={2000} open={open} handClose={handClose} />     
            <Snackbar open={openAlertaGeneral} onClose={handleCloseAlertaGeneral}>
                <Alert variant="filled" severity="info" elevation={6} onClose={handleCloseAlertaGeneral}>
                    NOTA: Si en el campo “Apellido de Casada” trae información, verificar si trae el “De” de casada, si no trae el “De” en el apellido de casada, agregar el “De” de forma manual de lo contrario no agregar nada.
                </Alert>
            </Snackbar>
            <ComponenteValidandoEstadosDelPadron data={props.datosSolicitudExtranjero} funcionObtenerEstadoEnElPadron={funcionObtenerEstadoEnElPadron}/>
            {
                errors.open && (
                    <AlertErrors errors={errors} setErrors={setErrors}/>
                )
            }
        </div>
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateUpdateUser);